<template>
  <div>
    <b-card
      no-body
      class="mb-2"
    >
      <b-card-header class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <feather-icon
            icon="SlidersIcon"
            size="20"
            class="text-primary mr-1"
          />
          <h4 class="mb-0">
            Signal Automation
          </h4>
        </div>
        <b-badge :variant="selectedRule ? 'light-success' : 'light-secondary'">
          {{ selectedRule ? 'kural seçili' : 'kural seçilmedi' }}
        </b-badge>
      </b-card-header>
      <b-card-body>
        <b-alert
          v-if="dataSaveStatus.message"
          :variant="dataSaveStatus.status ? 'success' : 'danger'"
          show
          class="mb-2"
        >
          {{ dataSaveStatus.message }}
        </b-alert>

        <b-alert
          show
          variant="light-info"
          class="mb-2"
        >
          <div class="d-flex flex-wrap align-items-center justify-content-between">
            <div class="mr-1">
              <b-form-checkbox
                v-model="form.hedgePairTradingPanelEnabled"
                switch
              >
                Hedge Pair Trading panelini göster
              </b-form-checkbox>
              <small class="text-muted d-block">
                İki farklı coin arasındaki spread/z-score ayrışmasını ayrı mod olarak yönetir.
              </small>
            </div>
            <b-button
              v-if="form.hedgePairTradingPanelEnabled"
              size="sm"
              variant="outline-primary"
              :to="{ name: 'HedgePairTrading' }"
            >
              <feather-icon
                icon="ShuffleIcon"
                size="14"
                class="mr-50"
              />
              Hedge panelini aç
            </b-button>
          </div>
        </b-alert>

        <b-row>
          <b-col
            cols="12"
            lg="4"
            class="mb-2"
          >
            <b-card
              no-body
              class="h-100"
            >
              <b-card-header class="d-flex align-items-center justify-content-between">
                <h5 class="mb-0">
                  Kurallar
                </h5>
                <b-button
                  size="sm"
                  variant="outline-primary"
                  @click="newRule"
                >
                  <feather-icon
                    icon="PlusIcon"
                    size="14"
                  />
                </b-button>
              </b-card-header>
              <b-card-body>
                <b-input-group class="mb-1">
                  <b-form-input
                    v-model="search"
                    placeholder="Kural ara"
                    @keyup.enter="fetchList"
                  />
                  <b-input-group-append>
                    <b-button
                      variant="primary"
                      :disabled="loading"
                      @click="fetchList"
                    >
                      <feather-icon
                        icon="SearchIcon"
                        size="14"
                      />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>

                <b-table
                  small
                  responsive
                  :items="dataList"
                  :fields="ruleFields"
                  :busy="loading"
                  show-empty
                  empty-text="Kural yok"
                >
                  <template #cell(name)="data">
                    <a
                      href="#"
                      @click.prevent="selectRule(data.item)"
                    >
                      {{ data.item.name }}
                    </a>
                    <div class="font-small-2 text-muted">
                      {{ data.item.engineKey || ('indicator #' + (data.item.indicatorId || '-')) }}
                    </div>
                  </template>
                  <template #cell(enabled)="data">
                    <b-badge :variant="data.item.enabled ? 'light-success' : 'light-secondary'">
                      {{ data.item.enabled ? 'aktif' : 'pasif' }}
                    </b-badge>
                  </template>
                  <template #cell(policy)="data">
                    <b-badge :variant="policyVariant(data.item.executionPolicy)">
                      {{ policyLabel(data.item.executionPolicy) }}
                    </b-badge>
                  </template>
                </b-table>
              </b-card-body>
            </b-card>
          </b-col>

          <b-col
            cols="12"
            lg="8"
            class="mb-2"
          >
            <b-card
              no-body
              class="h-100"
            >
              <b-card-header class="d-flex align-items-center justify-content-between">
                <h5 class="mb-0">
                  Rule Builder
                </h5>
                <div>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    class="mr-50"
                    :disabled="!selectedRule"
                    @click="archiveRule"
                  >
                    <feather-icon
                      icon="ArchiveIcon"
                      size="14"
                    />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="primary"
                    :disabled="saving"
                    @click="saveRule"
                  >
                    <feather-icon
                      icon="SaveIcon"
                      size="14"
                      class="mr-50"
                    />
                    Kaydet
                  </b-button>
                </div>
              </b-card-header>
              <b-card-body>
                <b-tabs content-class="pt-2">
                  <b-tab
                    title="Temel"
                    active
                  >
                    <b-row>
                      <b-col
                        cols="12"
                        md="6"
                      >
                        <b-form-group label="Ad">
                          <b-form-input v-model="form.name" />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Scope">
                          <b-form-select
                            v-model="form.scope"
                            :options="scopeOptions"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Durum">
                          <b-form-checkbox
                            v-model="form.enabled"
                            switch
                          >
                            Aktif
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Target ID">
                          <b-form-input
                            v-model.number="form.targetId"
                            type="number"
                            min="1"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Engine Key">
                          <b-form-input
                            v-model="form.engineKey"
                            placeholder="triple-ma-forecast-signals-v1.1"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Market">
                          <b-form-select
                            v-model="form.market"
                            :options="marketOptions"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Coin havuzu ve TF seçimi">
                          <b-form-radio-group
                            v-model="form.coinPoolTfMode"
                            :options="coinPoolTfModeOptions"
                            buttons
                            button-variant="outline-primary"
                            size="sm"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="form.coinPoolTfMode === 'EDGE_LIBRARY'"
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Edge tipi">
                          <b-form-select
                            v-model="form.edgeKind"
                            :options="edgeKindOptions"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="form.coinPoolTfMode === 'EDGE_LIBRARY'"
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Top N edge">
                          <b-form-input
                            v-model.number="form.topNEdges"
                            type="number"
                            min="1"
                            max="500"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="form.coinPoolTfMode === 'EDGE_LIBRARY'"
                        cols="12"
                        md="4"
                        class="d-flex align-items-center"
                      >
                        <b-form-checkbox
                          v-model="form.useEdgeTimeframes"
                          switch
                        >
                          TF edge'den alınsın
                        </b-form-checkbox>
                      </b-col>
                      <b-col
                        v-if="form.coinPoolTfMode === 'FIXED_POOL' || !form.useEdgeTimeframes"
                        cols="12"
                        md="6"
                      >
                        <b-form-group label="Timeframe">
                          <b-form-input
                            v-model="form.timeframesText"
                            placeholder="30m,1h,4h"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="form.coinPoolTfMode === 'FIXED_POOL'"
                        cols="12"
                        md="6"
                      >
                        <b-form-group label="Coinler">
                          <b-form-input
                            v-model="form.coinsText"
                            placeholder="Boşsa target pool"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="6"
                      >
                        <b-form-group label="Tabela skor min">
                          <b-form-input
                            v-model.number="form.marketScoreGateMin"
                            type="number"
                            min="0"
                            max="100"
                            step="1"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="6"
                      >
                        <b-form-group label="Tabela skor max">
                          <b-form-input
                            v-model.number="form.marketScoreGateMax"
                            type="number"
                            min="0"
                            max="100"
                            step="1"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-tab>

                  <b-tab title="Filtre">
                    <b-row>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-checkbox
                          v-model="form.sideLong"
                          switch
                        >
                          LONG
                        </b-form-checkbox>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-checkbox
                          v-model="form.sideShort"
                          switch
                        >
                          SHORT
                        </b-form-checkbox>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Min skor">
                          <b-form-input
                            v-model.number="form.minScore"
                            type="number"
                            min="0"
                            max="1"
                            step="0.01"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Min güven">
                          <b-form-input
                            v-model.number="form.minConfidence"
                            type="number"
                            min="0"
                            max="1"
                            step="0.01"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Maks. bar yaşı">
                          <b-form-input
                            v-model.number="form.maxSignalAgeBars"
                            type="number"
                            min="0"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Maks. dakika">
                          <b-form-input
                            v-model.number="form.maxSignalAgeMinutes"
                            type="number"
                            min="0"
                            max="10080"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Maks. MAE %">
                          <b-form-input
                            v-model.number="form.maxMaePct"
                            type="number"
                            min="0"
                            step="0.1"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Min. MFE %">
                          <b-form-input
                            v-model.number="form.minMfePct"
                            type="number"
                            step="0.1"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-checkbox
                          v-model="form.blockDuplicateSignal"
                          switch
                          class="mr-2 d-inline-block"
                        >
                          Duplicate sinyali engelle
                        </b-form-checkbox>
                        <b-form-checkbox
                          v-model="form.blockSameSymbolOpenPosition"
                          switch
                          class="d-inline-block"
                        >
                          Aynı coin açık pozisyonu engelle
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                  </b-tab>

                  <b-tab title="Atama / Bütçe">
                    <b-row>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Çalışma modu">
                          <b-form-select
                            v-model="form.executionMode"
                            :options="modeOptions"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="form.executionMode === 'LIVE'"
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Canlı API key">
                          <b-form-select
                            v-model.number="form.apiKeyId"
                            :options="apiKeyOptions"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="form.executionMode === 'LIVE'"
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.acknowledgeLiveExecutionRisk"
                          switch
                          class="mt-2"
                        >
                          Canlı işlem riskini onaylıyorum
                        </b-form-checkbox>
                      </b-col>
                      <b-col
                        v-if="form.executionMode === 'LIVE'"
                        cols="12"
                      >
                        <b-alert
                          show
                          variant="warning"
                          class="mb-1"
                        >
                          LIVE seçilirse otomatik execute gerçek emir gönderebilir. Yeni bot oluşturma için API key zorunludur; sadece mevcut bot kullan modunda botun kendi API key'i kullanılır.
                        </b-alert>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Bot seçimi">
                          <b-form-select
                            v-model="form.botSelectionMode"
                            :options="botSelectionOptions"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Oluşturulacak bot limiti">
                          <b-form-input
                            v-model.number="form.maxBotsToCreate"
                            type="number"
                            min="0"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Aynı coin pozisyon limiti">
                          <b-form-input
                            v-model.number="form.maxSameSymbolPositions"
                            type="number"
                            min="0"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-checkbox
                          v-model="form.budgetEnabled"
                          switch
                        >
                          Bütçe aktif
                        </b-form-checkbox>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Günlük yeni pozisyon">
                          <b-form-input
                            v-model.number="form.dailyMaxNewPositions"
                            type="number"
                            min="0"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Maks. açık pozisyon">
                          <b-form-input
                            v-model.number="form.maxOpenPositions"
                            type="number"
                            min="0"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Bot başı margin">
                          <b-form-input
                            v-model.number="form.maxPerPositionMarginUsdt"
                            type="number"
                            min="0"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <hr>
                        <div class="text-muted font-small-2 mb-50">
                          İşlem ayarları
                        </div>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="TP %">
                          <b-form-input
                            v-model.number="form.tpPerc"
                            type="number"
                            min="0.01"
                            step="0.1"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="SL %">
                          <b-form-input
                            v-model.number="form.slPerc"
                            type="number"
                            min="0.01"
                            step="0.1"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Kaldıraç">
                          <b-form-input
                            v-model.number="form.leverage"
                            type="number"
                            min="1"
                            step="1"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Komisyon / yön %">
                          <b-form-input
                            v-model.number="form.commissionPerSide"
                            type="number"
                            min="0"
                            step="0.01"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <div class="border rounded p-1 mb-1">
                          <b-row>
                            <b-col
                              cols="12"
                              md="4"
                            >
                              <b-form-checkbox
                                v-model="form.adaptiveTpSlSynchronizerEnabled"
                                switch
                              >
                                Adaptif TP ve SL senkronizer
                              </b-form-checkbox>
                              <small class="text-muted d-block">
                                Her run'da aktif havuz MFE/MAE persentillerine göre TP/SL'i günceller.
                              </small>
                            </b-col>
                            <b-col
                              cols="12"
                              md="4"
                            >
                              <b-form-checkbox
                                v-model="form.adaptiveTpSlKeepProfitMarginEnabled"
                                switch
                                :disabled="!form.adaptiveTpSlSynchronizerEnabled"
                              >
                                Kar marjını sabit tut
                              </b-form-checkbox>
                              <small class="text-muted d-block">
                                Yeni SL'e göre mevcut TP-SL mesafesi mümkün olduğunca korunur.
                              </small>
                            </b-col>
                            <b-col
                              cols="12"
                              md="4"
                            >
                              <b-form-group label="MAE tampon / kar marjı %">
                                <b-form-input
                                  v-model.number="form.adaptiveTpSlMaeCutPercent"
                                  type="number"
                                  min="0"
                                  max="95"
                                  step="1"
                                  :disabled="!form.adaptiveTpSlSynchronizerEnabled"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="12"
                              md="4"
                            >
                              <b-form-group label="MFE persentil">
                                <b-form-input
                                  v-model.number="form.adaptiveTpSlMfePercentile"
                                  type="number"
                                  min="1"
                                  max="99"
                                  step="1"
                                  :disabled="!form.adaptiveTpSlSynchronizerEnabled"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="12"
                              md="4"
                            >
                              <b-form-group label="MAE persentil">
                                <b-form-input
                                  v-model.number="form.adaptiveTpSlMaePercentile"
                                  type="number"
                                  min="1"
                                  max="99"
                                  step="1"
                                  :disabled="!form.adaptiveTpSlSynchronizerEnabled"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="12"
                              md="4"
                            >
                              <b-form-group label="Rolling run penceresi">
                                <b-form-input
                                  v-model.number="form.adaptiveTpSlRollingWindowRuns"
                                  type="number"
                                  min="1"
                                  max="24"
                                  step="1"
                                  :disabled="!form.adaptiveTpSlSynchronizerEnabled"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="12"
                              md="4"
                            >
                              <b-form-group label="Maks. TP %">
                                <b-form-input
                                  v-model.number="form.adaptiveTpSlMaxTpPerc"
                                  type="number"
                                  min="0.01"
                                  max="100"
                                  step="0.1"
                                  :disabled="!form.adaptiveTpSlSynchronizerEnabled"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="12"
                              md="4"
                            >
                              <b-form-group label="Maks. SL %">
                                <b-form-input
                                  v-model.number="form.adaptiveTpSlMaxSlPerc"
                                  type="number"
                                  min="0.01"
                                  max="100"
                                  step="0.1"
                                  :disabled="!form.adaptiveTpSlSynchronizerEnabled"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="12"
                              md="4"
                            >
                              <b-form-checkbox
                                v-model="form.adaptiveTpSlSymbolAdaptationEnabled"
                                switch
                                :disabled="!form.adaptiveTpSlSynchronizerEnabled"
                              >
                                Sembol bazlı adaptasyon
                              </b-form-checkbox>
                            </b-col>
                            <b-col
                              cols="12"
                              md="4"
                            >
                              <b-form-group label="Sembol ağırlığı %">
                                <b-form-input
                                  v-model.number="form.adaptiveTpSlSymbolWeightPercent"
                                  type="number"
                                  min="0"
                                  max="100"
                                  step="1"
                                  :disabled="!form.adaptiveTpSlSynchronizerEnabled || !form.adaptiveTpSlSymbolAdaptationEnabled"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="12"
                              md="4"
                            >
                              <div class="d-flex flex-column h-100 justify-content-center">
                                <b-button
                                  variant="primary"
                                  size="sm"
                                  :disabled="!form.id || !form.adaptiveTpSlSynchronizerEnabled || saving || adaptiveTpSlApplying"
                                  @click="applyAdaptiveTpSlNow"
                                >
                                  {{ adaptiveTpSlApplying ? 'Adapte ediliyor...' : 'Adapte et' }}
                                </b-button>
                                <small class="text-muted d-block mt-50">
                                  Run beklemeden mevcut havuza göre TP/SL'i hemen uygular.
                                </small>
                              </div>
                            </b-col>
                            <b-col
                              cols="12"
                              md="4"
                            >
                              <b-form-checkbox
                                v-model="form.adaptiveTpSlAlignProfitLossCleanupEnabled"
                                switch
                                :disabled="!form.adaptiveTpSlSynchronizerEnabled"
                              >
                                Profit Loss Cleanup TP'ye göre hizala
                              </b-form-checkbox>
                              <small class="text-muted d-block">
                                Cleanup min +PnL, SL→TP bandındaki seçilen noktaya çekilir.
                              </small>
                            </b-col>
                            <b-col
                              cols="12"
                              md="4"
                            >
                              <b-form-group
                                label="Cleanup band oranı (%)"
                                label-for="adaptive-tp-sl-cleanup-band-percent"
                              >
                                <b-form-input
                                  id="adaptive-tp-sl-cleanup-band-percent"
                                  v-model.number="form.adaptiveTpSlProfitLossCleanupBandPercent"
                                  type="number"
                                  min="0"
                                  max="100"
                                  step="1"
                                  :disabled="!form.adaptiveTpSlSynchronizerEnabled || !form.adaptiveTpSlAlignProfitLossCleanupEnabled"
                                />
                                <small class="text-muted">
                                  Örn. SL 3 / TP 5 / %60 → cleanup min +PnL 4.2.
                                </small>
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="12"
                              md="4"
                            >
                              <b-form-checkbox
                                v-model="form.adaptiveTpSlSyncOpportunityControlsEnabled"
                                switch
                                :disabled="!form.adaptiveTpSlSynchronizerEnabled"
                              >
                                Aktif Opportunity eşiklerini senkronize et
                              </b-form-checkbox>
                              <small class="text-muted d-block">
                                Açık kar havuzu ve zarar kesici eşikleri yeni TP/SL bandına uyarlanır.
                              </small>
                            </b-col>
                            <b-col cols="12">
                              <div class="d-flex flex-wrap text-muted font-small-2 mt-50">
                                <span class="mr-2">Şu an TP/SL: <strong>{{ formatPercentValue(form.tpPerc) }} / {{ formatPercentValue(form.slPerc) }}</strong></span>
                                <span class="mr-2">Önceki TP/SL: <strong>{{ formatPercentValue(form.adaptiveTpSlPreviousTpPerc) }} / {{ formatPercentValue(form.adaptiveTpSlPreviousSlPerc) }}</strong></span>
                                <span class="mr-2">İşlenen MFE/MAE: <strong>{{ formatPercentValue(form.adaptiveTpSlCurrentMfePct) }} / {{ formatPercentValue(form.adaptiveTpSlCurrentMaePct) }}</strong></span>
                                <span>Önceki MFE/MAE: <strong>{{ formatPercentValue(form.adaptiveTpSlPreviousMfePct) }} / {{ formatPercentValue(form.adaptiveTpSlPreviousMaePct) }}</strong></span>
                              </div>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.longShortBalanceEnabled"
                          switch
                        >
                          Long/Short dengesi
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Yeni pozisyonlar tek yöne aşırı yığılmasın.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.pairBalancedEntriesEnabled"
                          switch
                        >
                          Dengeli eşli atama
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Uygun olduğunda LONG ve SHORT adayı aynı run içinde birlikte atanır; tek slotta denge bozan giriş bekletilir.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.pairSuitableCoinsEnabled"
                          switch
                          :disabled="!form.pairBalancedEntriesEnabled"
                        >
                          Uygun coinleri eşleştir
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Eşli atamada coin uyumunu tercih eder; uygun eş yoksa mevcut skor sırası korunur.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.pairHedgeOnlyEnabled"
                          switch
                          :disabled="!form.pairBalancedEntriesEnabled"
                        >
                          Sadece hedge
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Eşler aynı coin üzerinde LONG/SHORT olur; aynı coin karşı yön yoksa atama bekler.
                        </small>
                      </b-col>
                      <b-col
                        v-if="form.pairHedgeOnlyEnabled"
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.pairImmediateHedgeRefillEnabled"
                          switch
                          :disabled="!form.pairBalancedEntriesEnabled || !form.pairHedgeOnlyEnabled"
                        >
                          Boş hedge slotlarını hemen doldur
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Boş kapasite varsa sinyal beklemeden aynı coin/TF LONG+SHORT çifti run içinde atanır.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Maks. yön baskısı %">
                          <b-form-input
                            v-model.number="form.maxDirectionalBiasPct"
                            type="number"
                            min="50"
                            max="100"
                            step="1"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-tab>

                  <b-tab title="Pozisyon Denge">
                    <b-row>
                      <b-col cols="12">
                        <div class="d-flex flex-wrap align-items-center justify-content-between mb-1">
                          <div class="text-muted font-small-2">
                            Pozisyon Denge Governor
                          </div>
                          <b-badge :variant="form.balanceGovernorEnabled ? 'light-success' : 'light-secondary'">
                            {{ form.balanceGovernorEnabled ? 'aktif' : 'pasif' }}
                          </b-badge>
                        </div>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorEnabled"
                          switch
                        >
                          Pozisyon dengesini koru
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Açıkken entry ve zarar kapatma kararları LONG/SHORT envanter dengesine göre sıralanır.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Denge modu">
                          <b-form-select
                            v-model="form.balanceGovernorMode"
                            :options="balanceGovernorModeOptions"
                            :disabled="!form.balanceGovernorEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Maks. yön farkı">
                          <b-form-input
                            v-model.number="form.balanceGovernorMaxSideGap"
                            type="number"
                            min="0"
                            max="20"
                            step="1"
                            :disabled="!form.balanceGovernorEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Tek slot davranışı">
                          <b-form-select
                            v-model="form.balanceGovernorOddSlotPolicy"
                            :options="balanceGovernorOddSlotOptions"
                            :disabled="!form.balanceGovernorEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorPreferEntries"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Entry'de dengeyi öncele
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Dengesiz envanterde eksik side'a giden entry öne alınır.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorPreferLossOffset"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Zarar kapatmada dengeyi öncele
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Kar sepeti zarar seçerken side gap'i azaltan pozisyonu tercih eder.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorRecomputeAfterClose"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Kapanış sonrası yeniden hesapla
                        </b-form-checkbox>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorBlockWhenImbalanced"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Dengesizken yeni entry'yi kısıtla
                        </b-form-checkbox>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorRebalanceProtectionEnabled"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Rebalance pozisyonlarını sıkı koru
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Eksik tarafa açılan poz zarar eşiğini geçerse SL beklemeden kapatılır.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Koruma bekleme dk">
                          <b-form-input
                            v-model.number="form.balanceGovernorRebalanceProtectionGraceMinutes"
                            type="number"
                            min="0"
                            max="240"
                            step="1"
                            :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorRebalanceProtectionEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Maks. rebalance zarar %">
                          <b-form-input
                            v-model.number="form.balanceGovernorRebalanceProtectionMaxLossPct"
                            type="number"
                            min="0.01"
                            max="100"
                            step="0.01"
                            :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorRebalanceProtectionEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Max rebalance close/run">
                          <b-form-input
                            v-model.number="form.balanceGovernorRebalanceProtectionMaxClosesPerRun"
                            type="number"
                            min="0"
                            max="10"
                            step="1"
                            :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorRebalanceProtectionEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorSequentialDamageTrimEnabled"
                          switch
                          :disabled="!form.balanceGovernorEnabled || form.balanceGovernorTransmissionMode !== 'SEQUENTIAL'"
                        >
                          Sıralı hasarı parçalı kırp
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Sıralı modda en eski/en yüksek -PnL bacağı SL'ye tam beden taşımadan küçültür.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-alert
                          show
                          variant="light-info"
                          class="mb-0"
                        >
                          Tetik eşiği <strong>Maks. rebalance zarar %</strong> alanını kullanır; kırpma realized + unrealized kar cover'ını aşmaz.
                        </b-alert>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Kırpma oranı %">
                          <b-form-input
                            v-model.number="form.balanceGovernorSequentialDamageTrimClosePercent"
                            type="number"
                            min="1"
                            max="95"
                            step="1"
                            :disabled="!form.balanceGovernorEnabled || form.balanceGovernorTransmissionMode !== 'SEQUENTIAL' || !form.balanceGovernorSequentialDamageTrimEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorPairScopedLossOffsetEnabled"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Her çift sadece kendi çiftinin zararını kapatır
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Pair izi olan pozisyonlarda kâr cover'ı sadece aynı çiftin zararına kullanılır.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorPairCloseCompanionEnabled"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Kapanan pozisyonda çifti de aynı anda kapansın
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Bir bacak tam kapanırsa açık eş bacak güvenli şekilde birlikte işlenir.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Eş bacak kapanış modu">
                          <b-form-select
                            v-model="form.balanceGovernorPairCloseCompanionMode"
                            :options="balanceGovernorPairCloseCompanionModeOptions"
                            :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorPairCloseCompanionEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <hr>
                        <div class="text-muted font-small-2 mb-50">
                          Şanzıman ve seviye kademeleri
                        </div>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Şanzıman tipi">
                          <b-form-select
                            v-model="form.balanceGovernorTransmissionMode"
                            :options="balanceGovernorTransmissionModeOptions"
                            :disabled="!form.balanceGovernorEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="form.balanceGovernorTransmissionMode === 'GRADUAL'"
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Önceki pozisyon kazanan bacak PnL'i (+/-)">
                          <b-form-input
                            v-model.number="form.balanceGovernorGradualTransmissionTriggerPnlPercent"
                            type="number"
                            min="-100"
                            max="100"
                            step="0.01"
                            :disabled="!form.balanceGovernorEnabled"
                          />
                          <small class="text-muted d-block mt-50">
                            Son açılan çiftin/pozisyonun kazanan bacağı bu PnL yüzdesine ulaşmadan yeni adım açılmaz.
                          </small>
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="form.balanceGovernorTransmissionMode === 'SEQUENTIAL' || form.balanceGovernorTransmissionMode === 'GRADUAL'"
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorTransmissionFallbackEnabled"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Bekleme timeout fallback
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Sıralı/kademeli mod takılı kalırsa belirlenen süreden sonra sıradaki çifte izin verir.
                        </small>
                      </b-col>
                      <b-col
                        v-if="(form.balanceGovernorTransmissionMode === 'SEQUENTIAL' || form.balanceGovernorTransmissionMode === 'GRADUAL') && form.balanceGovernorTransmissionFallbackEnabled"
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Maks. bekleme dakika">
                          <b-form-input
                            v-model.number="form.balanceGovernorTransmissionFallbackWaitMinutes"
                            type="number"
                            min="1"
                            max="10080"
                            step="1"
                            :disabled="!form.balanceGovernorEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Başlangıç seviyesi">
                          <b-form-input
                            v-model.number="form.balanceGovernorInitialTransmissionLevel"
                            type="number"
                            min="1"
                            max="4"
                            step="0.5"
                            :disabled="!form.balanceGovernorEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorStartTransmissionFromActiveLevels"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Başlangıçta tarafları aktif seviyelerine göre başlat
                        </b-form-checkbox>
                        <small class="text-muted d-block mt-50">
                          Açık pozisyon yokken LONG/SHORT ilk seviyeleri aktif coin havuzundaki sinyal ağırlığına göre hesaplanır.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Kararlı yön run sayısı">
                          <b-form-input
                            v-model.number="form.balanceGovernorStableDirectionRunsRequired"
                            type="number"
                            min="1"
                            max="120"
                            step="1"
                            :disabled="!form.balanceGovernorEnabled"
                          />
                          <small class="text-muted d-block mt-50">
                            Ortak eşik: ABSOLUTE modda reversal guard'ı, MFE momentum modunda self-correct'i, ve her iki modda sembol-bazlı ağırlık devreye alımını (bir sembolde arka arkaya bu kadar kazançlı kapanış olunca o tarafa ağırlık binmesi) besler. Düşürmek (örn. 2→1) → ağırlığı daha hızlı devreye alır/de-eskale eder.
                          </small>
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorLowScoreUncertainSwapEnabled"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Düşük skor ve kararsız piyasada takas swaplarını aktifleştir
                        </b-form-checkbox>
                        <small class="text-muted d-block mt-50">
                          Ana tabela seçilen kararsız modda ve skor eşik altındaysa LONG/SHORT seviye, margin ve kaldıraç değerleri değiş tokuş edilir.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Swap / cruise için en yüksek yön tabelası puanı">
                          <b-form-input
                            v-model.number="form.balanceGovernorLowScoreUncertainSwapMaxScore"
                            type="number"
                            min="0"
                            max="100"
                            step="1"
                            :disabled="!form.balanceGovernorEnabled || (!form.balanceGovernorLowScoreUncertainSwapEnabled && !form.balanceGovernorCruiseControlEnabled)"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorCruiseControlEnabled"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Cruise control (yumuşak denge)
                        </b-form-checkbox>
                        <small class="text-muted d-block mt-50">
                          Düşük skorlu range/karışık piyasada ağır tarafın notional farkını yumuşatır.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Swap / cruise piyasa modu">
                          <b-form-select
                            v-model="form.balanceGovernorLowScoreUncertainSwapMarketMode"
                            :options="balanceGovernorLowScoreUncertainSwapMarketModeOptions"
                            :disabled="!form.balanceGovernorEnabled || (!form.balanceGovernorLowScoreUncertainSwapEnabled && !form.balanceGovernorCruiseControlEnabled)"
                          />
                          <small class="text-muted d-block mt-50">
                            Swap cooldown'u Kararlı yön run sayısından beslenir; cruise bu skor ve mod eşiğini kullanır.
                          </small>
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Karşı yön seviye düşürme">
                          <b-form-input
                            v-model.number="form.balanceGovernorCounterSideLevelStepDown"
                            type="number"
                            min="0"
                            max="4"
                            step="0.5"
                            :disabled="!form.balanceGovernorEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Tabela onay step">
                          <b-form-input
                            v-model.number="form.balanceGovernorMarketTableConfirmationStep"
                            type="number"
                            min="0"
                            max="4"
                            step="0.5"
                            :disabled="!form.balanceGovernorEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorReversalGuardEnabled"
                          switch
                          :disabled="!form.balanceGovernorEnabled || form.balanceGovernorSteeringModeMfe"
                        >
                          Reversal koruması (otomatik de-eskalasyon)
                        </b-form-checkbox>
                        <small class="text-muted d-block mt-50">
                          Açık; tabela, PnL'de önde görünen tarafı kararlı run sayısı boyunca ters gösterirse ağır tarafı otomatik olarak nötre indirir. Savunma amaçlıdır (yeni yöne geçmez, nötrler). Koşul oluşunca kendi açılır, reversal çözülünce kendi kapanır.
                          <span
                            v-if="form.balanceGovernorSteeringModeMfe"
                            class="text-warning d-block"
                          >MFE momentum modunda bu koruma zaten dahildir, ayrıca gerekmez.</span>
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorSteeringModeMfe"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Momentum + MFE/MAE yönlendirme
                        </b-form-checkbox>
                        <small class="text-muted d-block mt-50">
                          Yön kararını mutlak PnL yerine son pencere PnL momentumu ve MFE/MAE kalitesinden alır. Dönüşü davranıştan erken yakalar ve gerçek kazanan tarafa geçer; kalite düşükse (chop) taraf tutmaz, churn'ü azaltır. Reversal korumasının işini de kapsar — açıkken o devreye girmez.
                        </small>
                        <b-form-group
                          v-if="form.balanceGovernorSteeringModeMfe"
                          class="mt-1"
                          label="Momentum kalite eşiği (0-1)"
                        >
                          <b-form-input
                            v-model.number="form.balanceGovernorMfeMomentumQualityMin"
                            type="number"
                            min="0"
                            max="1"
                            step="0.05"
                            :disabled="!form.balanceGovernorEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Transfer modu">
                          <b-form-select
                            v-model="form.balanceGovernorTransferMode"
                            :options="balanceGovernorTransferModeOptions"
                            :disabled="!form.balanceGovernorEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Winner aktarım tekniği">
                          <b-form-select
                            v-model="form.balanceGovernorTransferAction"
                            :options="balanceGovernorTransferActionOptions"
                            :disabled="!form.balanceGovernorEnabled || form.balanceGovernorTransferMode !== 'REALTIME'"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-table
                          small
                          responsive
                          bordered
                          :items="transmissionLevelRows"
                          :fields="transmissionLevelFields"
                          class="mb-1"
                        >
                          <template #cell(longLeverage)="slot">
                            <b-form-input
                              v-model.number="form.balanceGovernorLongLeverageLevels[slot.index]"
                              type="number"
                              min="1"
                              :max="maxTransmissionLeverage"
                              step="1"
                              :disabled="!form.balanceGovernorEnabled"
                            />
                          </template>
                          <template #cell(shortLeverage)="slot">
                            <b-form-input
                              v-model.number="form.balanceGovernorShortLeverageLevels[slot.index]"
                              type="number"
                              min="1"
                              :max="maxTransmissionLeverage"
                              step="1"
                              :disabled="!form.balanceGovernorEnabled"
                            />
                          </template>
                          <template #cell(longMargin)="slot">
                            <b-form-input
                              v-model.number="form.balanceGovernorLongMarginLevelPercents[slot.index]"
                              type="number"
                              min="0"
                              max="100"
                              step="1"
                              :disabled="!form.balanceGovernorEnabled"
                            />
                          </template>
                          <template #cell(shortMargin)="slot">
                            <b-form-input
                              v-model.number="form.balanceGovernorShortMarginLevelPercents[slot.index]"
                              type="number"
                              min="0"
                              max="100"
                              step="1"
                              :disabled="!form.balanceGovernorEnabled"
                            />
                          </template>
                          <template #cell(autoIncrease)="slot">
                            <b-form-input
                              v-model.number="form.balanceGovernorAutoManageTransmissionLevelIncreasePercents[slot.index]"
                              type="number"
                              min="0"
                              max="100"
                              step="0.5"
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorAutoManageTransmissionLevelsEnabled"
                            />
                          </template>
                        </b-table>
                        <small class="text-muted d-block mb-1">
                          Kaldıraçlar tam sayı uygulanır; ara seviye sadece margin/ağırlık puanı için kullanılır.
                        </small>
                      </b-col>
                      <b-col cols="12">
                        <div class="d-flex flex-wrap align-items-center justify-content-between mb-50">
                          <div class="text-muted font-small-2">
                            Otomatik seviye yönetimi
                          </div>
                          <b-badge :variant="form.balanceGovernorAutoManageTransmissionLevelsEnabled ? 'light-success' : 'light-secondary'">
                            {{ form.balanceGovernorAutoManageTransmissionLevelsEnabled ? 'aktif' : 'pasif' }}
                          </b-badge>
                        </div>
                        <b-form-checkbox
                          v-model="form.balanceGovernorAutoManageTransmissionLevelsEnabled"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Otomatik yönet
                        </b-form-checkbox>
                        <b-row class="mt-1">
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <label>Tetikleme modu</label>
                            <b-form-radio-group
                              v-model="form.balanceGovernorAutoManageTransmissionTriggerMode"
                              :options="balanceGovernorAutoManageTransmissionTriggerModeOptions"
                              buttons
                              button-variant="outline-primary"
                              size="sm"
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorAutoManageTransmissionLevelsEnabled"
                            />
                          </b-col>
                          <b-col
                            v-if="form.balanceGovernorAutoManageTransmissionTriggerMode !== 'CLOSED_TRADES'"
                            cols="12"
                            md="4"
                          >
                            <label>Net realize PnL eşik (%)</label>
                            <b-form-input
                              v-model.number="form.balanceGovernorAutoManageTransmissionRealizedProfitTriggerPct"
                              type="number"
                              min="0.01"
                              max="100"
                              step="0.05"
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorAutoManageTransmissionLevelsEnabled"
                            />
                          </b-col>
                          <b-col
                            v-else
                            cols="12"
                            md="4"
                          >
                            <label>Toplam kapanış eşiği</label>
                            <b-form-input
                              v-model.number="form.balanceGovernorAutoManageTransmissionClosedTradesTriggerCount"
                              type="number"
                              min="1"
                              max="1000000"
                              step="1"
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorAutoManageTransmissionLevelsEnabled"
                            />
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <label>Uygulanan son basamak</label>
                            <b-form-input
                              v-model.number="form.balanceGovernorAutoManageTransmissionLastAppliedStep"
                              type="number"
                              min="0"
                              max="4"
                              step="1"
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorAutoManageTransmissionLevelsEnabled"
                            />
                          </b-col>
                        </b-row>
                        <small class="text-muted d-block mt-50 mb-1">
                          PnL modunda net realized kâr / toplam kural bütçesi oranı izlenir. Kapanış modunda toplam kapanış adedi eşiği izlenir. Her basamakta tablodaki seviyeler satırdaki artış yüzdesi kadar kalıcı büyütülür; unrealized PnL dahil edilmez.
                        </small>
                      </b-col>
                      <b-col cols="12">
                        <hr>
                        <div class="d-flex flex-wrap align-items-center justify-content-between mb-50">
                          <div class="text-muted font-small-2">
                            Hedge pair lifecycle / damage manager
                          </div>
                          <b-badge :variant="form.balanceGovernorHedgePairLifecycleEnabled ? 'light-warning' : 'light-secondary'">
                            {{ form.balanceGovernorHedgePairLifecycleEnabled ? 'aktif' : 'kapalı' }}
                          </b-badge>
                        </div>
                        <b-form-checkbox
                          v-model="form.balanceGovernorHedgePairLifecycleEnabled"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Winner/loser tarafını pair bazlı yönet, loser'ı kontrollü kırp, winner'ı runner/trailing olarak koru
                        </b-form-checkbox>
                        <small class="text-muted d-block mt-50 mb-1">
                          Bu alandaki PnL yüzdeleri TP/SL ile aynı zemindedir: ham fiyat hareketi yüzdesi, kaldıraçlı ROE değildir.
                        </small>
                        <b-row class="mt-1">
                          <b-col
                            cols="12"
                            md="3"
                          >
                            <b-form-group label="Winner min PnL %">
                              <b-form-input
                                v-model.number="form.balanceGovernorHedgePairWinnerMinPnlPercent"
                                type="number"
                                min="0"
                                max="100"
                                step="0.01"
                                :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="3"
                          >
                            <b-form-group label="Winner min net USDT">
                              <b-form-input
                                v-model.number="form.balanceGovernorHedgePairWinnerMinNetUsdt"
                                type="number"
                                min="0"
                                step="0.01"
                                :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="3"
                          >
                            <b-form-group label="Winner onay run">
                              <b-form-input
                                v-model.number="form.balanceGovernorHedgePairWinnerConfirmRuns"
                                type="number"
                                min="1"
                                max="120"
                                step="1"
                                :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="3"
                          >
                            <b-form-group label="MFE/MAE min oran">
                              <b-form-input
                                v-model.number="form.balanceGovernorHedgePairWinnerMfeMaeMinRatio"
                                type="number"
                                min="0"
                                max="100"
                                step="0.05"
                                :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled || !form.balanceGovernorHedgePairWinnerMfeMaeConfirmEnabled"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col cols="12">
                            <b-form-checkbox
                              v-model="form.balanceGovernorHedgePairWinnerMfeMaeConfirmEnabled"
                              switch
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                            >
                              Winner onayında MFE/MAE oranını kullan
                            </b-form-checkbox>
                          </b-col>
                        </b-row>
                        <b-row class="mt-1">
                          <b-col
                            cols="12"
                            md="3"
                          >
                            <b-form-group label="İlk loser kırpma %">
                              <b-form-input
                                v-model.number="form.balanceGovernorHedgePairLoserFirstTrimPercent"
                                type="number"
                                min="1"
                                max="95"
                                step="1"
                                :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="3"
                          >
                            <b-form-group label="İkinci loser kırpma %">
                              <b-form-input
                                v-model.number="form.balanceGovernorHedgePairLoserSecondTrimPercent"
                                type="number"
                                min="1"
                                max="95"
                                step="1"
                                :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="3"
                          >
                            <b-form-group label="Max trim / pair">
                              <b-form-input
                                v-model.number="form.balanceGovernorHedgePairMaxTrimCount"
                                type="number"
                                min="1"
                                max="10"
                                step="1"
                                :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="3"
                          >
                            <b-form-group label="Max trim / run">
                              <b-form-input
                                v-model.number="form.balanceGovernorHedgePairMaxLoserTrimPerRun"
                                type="number"
                                min="1"
                                max="10"
                                step="1"
                                :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="3"
                          >
                            <b-form-group label="Loser min zarar %">
                              <b-form-input
                                v-model.number="form.balanceGovernorHedgePairLoserMinLossPercent"
                                type="number"
                                min="0"
                                max="100"
                                step="0.01"
                                :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="3"
                          >
                            <b-form-group label="Winner kâr kullanım %">
                              <b-form-input
                                v-model.number="form.balanceGovernorHedgePairWinnerProfitUsablePercent"
                                type="number"
                                min="0"
                                max="100"
                                step="1"
                                :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="3"
                          >
                            <b-form-group label="Lifecycle trail tetik %">
                              <b-form-input
                                v-model.number="form.balanceGovernorHedgePairWinnerTrailingTriggerPnlPct"
                                type="number"
                                min="0"
                                max="100"
                                step="0.01"
                                :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled || !form.balanceGovernorHedgePairActivateWinnerTrailingOnTrim"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="3"
                          >
                            <b-form-group label="Lifecycle trail offset %">
                              <b-form-input
                                v-model.number="form.balanceGovernorHedgePairWinnerTrailingOffsetPnlPct"
                                type="number"
                                min="0.01"
                                max="100"
                                step="0.01"
                                :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled || !form.balanceGovernorHedgePairActivateWinnerTrailingOnTrim"
                              />
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <b-form-checkbox
                              v-model="form.balanceGovernorHedgePairUseRealizedBuffer"
                              switch
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                            >
                              Realized buffer kullan
                            </b-form-checkbox>
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <b-form-checkbox
                              v-model="form.balanceGovernorHedgePairUseUnrealizedWinnerAssist"
                              switch
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                            >
                              Unrealized winner assist kullan
                            </b-form-checkbox>
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <b-form-checkbox
                              v-model="form.balanceGovernorHedgePairActivateWinnerTrailingOnTrim"
                              switch
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                            >
                              Loser kırpılınca winner trailing başlat
                            </b-form-checkbox>
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <b-form-checkbox
                              v-model="form.balanceGovernorHedgePairProtectWinnerFromGeneralCleanup"
                              switch
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                            >
                              Winner'ı genel cleanup'tan koru
                            </b-form-checkbox>
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <b-form-checkbox
                              v-model="form.balanceGovernorHedgePairOnlySamePairCleanup"
                              switch
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                            >
                              Sadece aynı pair zararını temizle
                            </b-form-checkbox>
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <b-form-checkbox
                              v-model="form.balanceGovernorHedgePairBlockGenericLossOffsetWhileManaged"
                              switch
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorHedgePairLifecycleEnabled"
                            >
                              Managed pair'de generic loss offset'i blokla
                            </b-form-checkbox>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="12">
                        <hr>
                        <div class="d-flex flex-wrap align-items-center justify-content-between mb-50">
                          <div class="text-muted font-small-2">
                            Eş bacak kapanınca kazanan trailing
                          </div>
                          <b-badge :variant="form.balanceGovernorPairWinnerTrailingEnabled ? 'light-success' : 'light-secondary'">
                            {{ form.balanceGovernorPairWinnerTrailingEnabled ? 'ticker aktif' : 'kapalı' }}
                          </b-badge>
                        </div>
                        <b-form-checkbox
                          v-model="form.balanceGovernorPairWinnerTrailingEnabled"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Çiftin bir bacağı kapandığında kazanan için trailing'i aktifleştir
                        </b-form-checkbox>
                        <b-row class="mt-1">
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <b-form-group label="Trail tetikleme %PnL">
                              <b-form-input
                                v-model.number="form.balanceGovernorPairWinnerTrailingTriggerPnlPct"
                                type="number"
                                min="0"
                                max="100"
                                step="0.05"
                                :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorPairWinnerTrailingEnabled"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <b-form-group label="Trail geri düşüm %PnL">
                              <b-form-input
                                v-model.number="form.balanceGovernorPairWinnerTrailingOffsetPnlPct"
                                type="number"
                                min="0.01"
                                max="100"
                                step="0.05"
                                :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorPairWinnerTrailingEnabled"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                            class="d-flex align-items-center"
                          >
                            <small class="text-muted">
                              Bu kontrol scheduler run'ını beklemez; açık bacak fiyat ticker'ında SL'i trailing kilit noktasına taşır. Yüzdeler fiyat hareketi PnL'idir, kaldıraçlı margin getirisi değildir.
                            </small>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="12">
                        <hr>
                        <div class="d-flex flex-wrap align-items-center justify-content-between mb-50">
                          <div class="text-muted font-small-2">
                            Otomatik denge reseti
                          </div>
                          <b-badge :variant="form.balanceGovernorAutoResetBalancesEnabled ? 'light-warning' : 'light-secondary'">
                            {{ form.balanceGovernorAutoResetBalancesEnabled ? 'aktif' : 'pasif' }}
                          </b-badge>
                        </div>
                        <b-form-checkbox
                          v-model="form.balanceGovernorAutoResetBalancesEnabled"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Dengeleri otomatik resetle
                        </b-form-checkbox>
                        <b-row class="mt-1">
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <b-form-checkbox
                              v-model="form.balanceGovernorAutoResetIntervalEnabled"
                              switch
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorAutoResetBalancesEnabled"
                            >
                              T dakikada sıfırla
                            </b-form-checkbox>
                            <b-form-input
                              v-model.number="form.balanceGovernorAutoResetIntervalMinutes"
                              class="mt-50"
                              type="number"
                              min="1"
                              max="10080"
                              step="1"
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorAutoResetBalancesEnabled || !form.balanceGovernorAutoResetIntervalEnabled"
                            />
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <b-form-checkbox
                              v-model="form.balanceGovernorAutoResetUnrealizedProfitEnabled"
                              switch
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorAutoResetBalancesEnabled"
                            >
                              +Unrealize PnL %P'de sıfırla
                            </b-form-checkbox>
                            <b-form-input
                              v-model.number="form.balanceGovernorAutoResetUnrealizedProfitPct"
                              class="mt-50"
                              type="number"
                              min="0"
                              max="100"
                              step="0.05"
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorAutoResetBalancesEnabled || !form.balanceGovernorAutoResetUnrealizedProfitEnabled"
                            />
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <b-form-checkbox
                              v-model="form.balanceGovernorAutoResetCloseAgedPairEnabled"
                              switch
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorAutoResetBalancesEnabled"
                            >
                              M dakika geçen çifti kapat
                            </b-form-checkbox>
                            <b-form-input
                              v-model.number="form.balanceGovernorAutoResetCloseAgedPairMinutes"
                              class="mt-50"
                              type="number"
                              min="1"
                              max="10080"
                              step="1"
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorAutoResetBalancesEnabled || !form.balanceGovernorAutoResetCloseAgedPairEnabled"
                            />
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <b-form-checkbox
                              v-model="form.balanceGovernorAutoResetUnrealizedVsRealizedEnabled"
                              switch
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorAutoResetBalancesEnabled"
                            >
                              UNR PnL, realize kârın %N üstündeyse sıfırla
                            </b-form-checkbox>
                            <b-form-input
                              v-model.number="form.balanceGovernorAutoResetUnrealizedVsRealizedPct"
                              class="mt-50"
                              type="number"
                              min="0"
                              max="1000"
                              step="1"
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorAutoResetBalancesEnabled || !form.balanceGovernorAutoResetUnrealizedVsRealizedEnabled"
                            />
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                          >
                            <b-form-checkbox
                              v-model="form.balanceGovernorAutoResetFakeProfitProtectionEnabled"
                              switch
                              :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorAutoResetBalancesEnabled"
                            >
                              Sahte kar koruması
                            </b-form-checkbox>
                            <small class="text-muted d-block mt-50">
                              Açık zararlar pozitif unrealized kârı bozuyorsa kâr bazlı reset tetiklerini bekletir.
                            </small>
                          </b-col>
                        </b-row>
                        <small class="text-muted d-block mt-50 mb-1">
                          Reset, otomatik seviye basamağını sıfırlar; kâr bazlı tetiklerde net defter pozitifse +PnL close kararı, yaşlanan çift kapatma aktifse pair close kararı üretir.
                        </small>
                      </b-col>
                      <b-col cols="12">
                        <hr>
                        <div class="d-flex flex-wrap align-items-center justify-content-between mb-50">
                          <div class="text-muted font-small-2">
                            Güvenli kapatma
                          </div>
                          <b-badge :variant="form.balanceGovernorSafeCloseEnabled ? 'light-warning' : 'light-secondary'">
                            {{ form.balanceGovernorSafeCloseEnabled ? 'sistem kapanmaya ayarlandı' : 'kapalı' }}
                          </b-badge>
                        </div>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.balanceGovernorSafeCloseEnabled"
                          switch
                          :disabled="!form.balanceGovernorEnabled"
                        >
                          Güvenli kapatma
                        </b-form-checkbox>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Kapatma modu">
                          <b-form-select
                            v-model="form.balanceGovernorSafeCloseMode"
                            :options="balanceGovernorSafeCloseModeOptions"
                            :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorSafeCloseEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Kar tüketim sınırı %">
                          <b-form-input
                            v-model.number="form.balanceGovernorSafeCloseMaxProfitGivebackPercent"
                            type="number"
                            min="0"
                            max="100"
                            step="1"
                            :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorSafeCloseEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="form.balanceGovernorSafeCloseMode === 'TARGETED'"
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Realize kar hedefi USDT">
                          <b-form-input
                            v-model.number="form.balanceGovernorSafeCloseRealizedProfitTargetUsdt"
                            type="number"
                            min="0"
                            step="1"
                            :disabled="!form.balanceGovernorEnabled || !form.balanceGovernorSafeCloseEnabled"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-tab>

                  <b-tab title="Portföy Yönetimi">
                    <b-row>
                      <b-col cols="12">
                        <div class="d-flex flex-wrap align-items-center justify-content-between mb-1">
                          <div class="text-muted font-small-2">
                            Profit Loss Cleanup
                          </div>
                          <b-badge :variant="form.profitLossCleanupEnabled ? 'light-success' : 'light-secondary'">
                            {{ form.profitLossCleanupEnabled ? 'aktif' : 'pasif' }}
                          </b-badge>
                        </div>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.profitLossCleanupEnabled"
                          switch
                        >
                          Profit Loss Cleanup
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Kar realize edilmeden zarar temizleme kararı üretmez.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Cleanup Mode">
                          <b-form-radio-group
                            v-model="form.profitLossCleanupMode"
                            :options="profitLossCleanupModeOptions"
                            :disabled="!form.profitLossCleanupEnabled"
                            stacked
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        v-if="form.profitLossCleanupMode === 'SINGLE_POSITION'"
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Minimum +PnL (%)">
                          <b-form-input
                            v-model.number="form.profitLossCleanupMinimumPnlPercent"
                            type="number"
                            min="0"
                            max="100"
                            step="0.05"
                            :disabled="!form.profitLossCleanupEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Cleanup Percentage (%)">
                          <b-form-input
                            v-model.number="form.profitLossCleanupPercent"
                            type="number"
                            min="0"
                            max="100"
                            step="1"
                            :disabled="!form.profitLossCleanupEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.profitLossCleanupPartialLossEnabled"
                          switch
                          :disabled="!form.profitLossCleanupEnabled"
                        >
                          Sığmayan zararı parçalı kapat
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Cleanup bütçesi tam kapatmaya yetmezse kalan zarar adaylarını aynı oranla azaltır.
                        </small>
                      </b-col>
                      <b-col cols="12">
                        <hr>
                        <div class="text-muted font-small-2 mb-50">
                          Realize kâr paylaştırma
                        </div>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-checkbox
                          v-model="form.distributeRealizedProfitToPositionsEnabled"
                          switch
                        >
                          Oluşan realize +PnL'i aktif pozisyon PnL'lerine paylaştır
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Realize kâr bütçesi pozisyon yönetimi için yeniden kullanılabilir hale gelir.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="8"
                      >
                        <b-form-group label="Paylaştırma zamanı">
                          <b-form-radio-group
                            v-model="form.realizedProfitDistributionTiming"
                            :options="realizedProfitDistributionTimingOptions"
                            :disabled="!form.distributeRealizedProfitToPositionsEnabled"
                            stacked
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Dağıtılacak realize kâr %">
                          <b-form-input
                            v-model.number="form.realizedProfitDistributionSharePct"
                            type="number"
                            min="0"
                            max="100"
                            step="1"
                            :disabled="!form.distributeRealizedProfitToPositionsEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Zarar tamponu %">
                          <b-form-input
                            v-model.number="form.realizedProfitDistributionReservePct"
                            type="number"
                            min="0"
                            max="100"
                            step="1"
                            :disabled="!form.distributeRealizedProfitToPositionsEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Kasada bırakılacak güvenlik %">
                          <b-form-input
                            v-model.number="form.realizedProfitDistributionSafetyPct"
                            type="number"
                            min="0"
                            max="100"
                            step="1"
                            :disabled="!form.distributeRealizedProfitToPositionsEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Max SL riski / tampon %">
                          <b-form-input
                            v-model.number="form.realizedProfitDistributionMaxSlRiskBufferPct"
                            type="number"
                            min="0"
                            max="100"
                            step="1"
                            :disabled="!form.distributeRealizedProfitToPositionsEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Pozisyon başı max ek USDT">
                          <b-form-input
                            v-model.number="form.realizedProfitDistributionMaxExtraPerPositionUsdt"
                            type="number"
                            min="0"
                            step="1"
                            :disabled="!form.distributeRealizedProfitToPositionsEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Bütçe büyütme üst limiti">
                          <b-form-input
                            v-model.number="form.realizedProfitDistributionMaxBudgetMultiplier"
                            type="number"
                            min="1"
                            max="20"
                            step="0.1"
                            :disabled="!form.distributeRealizedProfitToPositionsEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Büyütme için min kâr USDT">
                          <b-form-input
                            v-model.number="form.realizedProfitDistributionMinProfitUsdt"
                            type="number"
                            min="0"
                            step="1"
                            :disabled="!form.distributeRealizedProfitToPositionsEnabled"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-tab>

                  <b-tab title="Opportunity / Çalıştırma">
                    <b-row>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Execution policy">
                          <b-form-select
                            v-model="form.executionPolicy"
                            :options="executionOptions"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Min fırsat farkı">
                          <b-form-input
                            v-model.number="form.minOpportunityScoreDelta"
                            type="number"
                            min="0"
                            max="1"
                            step="0.01"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="4"
                      >
                        <b-form-group label="Geç giriş riski">
                          <b-form-select
                            v-model="form.maxLateEntryRisk"
                            :options="lateRiskOptions"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-checkbox
                          v-model="form.allowOpenNewPosition"
                          switch
                          class="mr-2 d-inline-block"
                        >
                          Yeni pozisyon açabilir
                        </b-form-checkbox>
                        <b-form-checkbox
                          v-model="form.immediateBotAssignmentEnabled"
                          switch
                          class="mr-2 d-inline-block"
                        >
                          Bot atanışlarını derhal gerçekleştir
                        </b-form-checkbox>
                        <b-form-checkbox
                          v-model="form.allowProtectExisting"
                          switch
                          class="mr-2 d-inline-block"
                        >
                          Mevcut pozisyonu koruyabilir
                        </b-form-checkbox>
                        <b-form-checkbox
                          v-model="form.allowCloseAndOpenNew"
                          switch
                          class="d-inline-block"
                        >
                          Kapatıp yeni fırsata dönebilir
                        </b-form-checkbox>
                        <b-form-checkbox
                          v-model="form.indicatorExitSignalEnabled"
                          switch
                          class="d-inline-block ml-2"
                        >
                          İndikatör exit sinyallerini uygula
                        </b-form-checkbox>
                        <small class="text-muted d-block mt-50">
                          Kapalıysa bu kuralın hedefindeki botlar opposite-signal indikatör exit ile pozisyon kapatmaz.
                        </small>
                      </b-col>
                      <b-col cols="12">
                        <hr>
                        <div class="text-muted font-small-2 mb-50">
                          Kar cebi
                        </div>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-checkbox
                          v-model="form.harvestProfitablePositions"
                          switch
                        >
                          Kar cebe yakışır
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Artı PnL toplam bütçe hedefini geçtiğinde winner pozisyon için kapatma kararı üretir.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-checkbox
                          v-model="form.lossOffsetCloseEnabled"
                          switch
                        >
                          Karla zararı kapat
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Artı PnL ile zararı karşılanan bir eksi pozisyon için kapatma kararı üretir.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-checkbox
                          v-model="form.requireProfitHarvestForLossOffset"
                          switch
                          :disabled="!form.lossOffsetCloseEnabled"
                        >
                          Kar alınmadan zarar kapatma
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Zarar kapatma sadece aynı çalışmada kar cebi kapanışı varsa üretilir.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-checkbox
                          v-model="form.harvestScopeBot"
                          switch
                        >
                          Kar cebi bot özelinde
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Kapalıysa genel net PnL sepeti, açıksa tek bot net PnL eşiği kullanılır.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Kar cebi hedef %">
                          <b-form-input
                            v-model.number="form.harvestBudgetPct"
                            type="number"
                            min="0"
                            max="100"
                            step="0.5"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Kar kapat min PnL %">
                          <b-form-input
                            v-model.number="form.profitCloseMinPnlPct"
                            type="number"
                            min="0"
                            max="100"
                            step="0.05"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-checkbox
                          v-model="form.lossOffsetProfitMultipleEnabled"
                          switch
                          :disabled="!form.lossOffsetCloseEnabled && !form.timedLossOffsetEnabled"
                        >
                          Zarar için kâr katı kullan
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Zarar sadece net kâr belirlenen katı kadar fazlaysa kapatılır.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Zarar kapatma kâr katı">
                          <b-form-input
                            v-model.number="form.lossOffsetProfitMultiple"
                            type="number"
                            min="1"
                            max="20"
                            step="0.25"
                            :disabled="!form.lossOffsetProfitMultipleEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Zarar kapat min PnL %">
                          <b-form-input
                            v-model.number="form.lossOffsetMinLossPct"
                            type="number"
                            min="0"
                            max="100"
                            step="0.05"
                            :disabled="!form.lossOffsetCloseEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-checkbox
                          v-model="form.lossOffsetLargestFirst"
                          switch
                          :disabled="!form.lossOffsetCloseEnabled && !form.timedLossOffsetEnabled"
                        >
                          {{ form.lossOffsetLargestFirst ? 'En yüksek zararı temizle' : 'En düşük zararı temizle' }}
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Zarar kapatma adaylarının sırasını belirler.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-checkbox
                          v-model="form.partialLossCloseEnabled"
                          switch
                          :disabled="!form.lossOffsetCloseEnabled && !form.timedLossOffsetEnabled"
                        >
                          Zararları parçalı kapat
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Zarar kapatma uygunsa pozisyonu tamamen değil, belirlenen yüzde kadar azaltır.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-checkbox
                          v-model="form.partialLossCloseAllEligible"
                          switch
                          :disabled="!form.partialLossCloseEnabled"
                        >
                          Tüm uygun zararları parçala
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Açıkken limit dolana kadar birden fazla uygun zarara partial karar üretir.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-checkbox
                          v-model="form.partialLossCloseThresholdEnabled"
                          switch
                          :disabled="!form.partialLossCloseEnabled"
                        >
                          Zarar eşiğiyle parçala
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Sadece belirlenen eksi PnL yüzdesini geçen zararlarda çalışır.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Parçalı kapat %">
                          <b-form-input
                            v-model.number="form.partialLossClosePercent"
                            type="number"
                            min="1"
                            max="100"
                            step="1"
                            :disabled="!form.partialLossCloseEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Partial zarar eşiği %">
                          <b-form-input
                            v-model.number="form.partialLossCloseThresholdPnlPct"
                            type="number"
                            min="0"
                            max="100"
                            step="0.05"
                            :disabled="!form.partialLossCloseEnabled || !form.partialLossCloseThresholdEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Max partial / run">
                          <b-form-input
                            v-model.number="form.maxPartialLossOffsetsPerRun"
                            type="number"
                            min="0"
                            max="10"
                            step="1"
                            :disabled="!form.partialLossCloseEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-checkbox
                          v-model="form.timedLossOffsetEnabled"
                          switch
                        >
                          Süreli zarar temizliği
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Sadece zamanı gelince ve net kâr karşılıyorsa çalışır.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Süreli temizlik dk">
                          <b-form-input
                            v-model.number="form.timedLossOffsetIntervalMinutes"
                            type="number"
                            min="1"
                            max="10080"
                            step="5"
                            :disabled="!form.timedLossOffsetEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Süreli zarar min PnL %">
                          <b-form-input
                            v-model.number="form.timedLossOffsetMinLossPct"
                            type="number"
                            min="0"
                            max="100"
                            step="0.05"
                            :disabled="!form.timedLossOffsetEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Süreli zarar temizleme % pay">
                          <b-form-input
                            v-model.number="form.timedLossOffsetProfitSharePct"
                            type="number"
                            min="0"
                            max="100"
                            step="1"
                            :disabled="!form.timedLossOffsetEnabled"
                          />
                          <small class="text-muted">
                            Realize +PnL'in bu oranı kadar zarar temizler.
                          </small>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <hr>
                        <div class="text-muted font-small-2 mb-50">
                          Hızlı zarar kesici
                        </div>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-checkbox
                          v-model="form.rapidLossCloseEnabled"
                          switch
                        >
                          Hızlı -PnL coini direkt kapat
                        </b-form-checkbox>
                        <small class="text-muted d-block">
                          Yeni açılan pozisyon belirlenen sürede hızlı zarara giderse kar sepeti beklemeden tam close üretir.
                        </small>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Hızlı zarar penceresi dk">
                          <b-form-input
                            v-model.number="form.rapidLossCloseWindowMinutes"
                            type="number"
                            min="1"
                            max="1440"
                            step="1"
                            :disabled="!form.rapidLossCloseEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Hızlı zarar min PnL %">
                          <b-form-input
                            v-model.number="form.rapidLossCloseMinLossPct"
                            type="number"
                            min="0"
                            max="100"
                            step="0.05"
                            :disabled="!form.rapidLossCloseEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Max hızlı close / run">
                          <b-form-input
                            v-model.number="form.maxRapidLossClosesPerRun"
                            type="number"
                            min="0"
                            max="10"
                            step="1"
                            :disabled="!form.rapidLossCloseEnabled"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                        class="mt-1"
                      >
                        <b-form-checkbox
                          v-model="form.scheduleEnabled"
                          switch
                        >
                          Scheduler aktif
                        </b-form-checkbox>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Interval dk">
                          <b-form-input
                            v-model.number="form.intervalMinutes"
                            type="number"
                            min="1"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Cooldown dk">
                          <b-form-input
                            v-model.number="form.cooldownMinutes"
                            type="number"
                            min="0"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="3"
                      >
                        <b-form-group label="Timeout sn">
                          <b-form-input
                            v-model.number="form.timeoutSeconds"
                            type="number"
                            min="5"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-checkbox
                          v-model="form.runAfterRescan"
                          switch
                        >
                          Rescan sonrası tetikle
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-row
      v-if="selectedRule"
      class="mb-2"
    >
      <b-col
        cols="12"
        md="3"
        class="mb-1 mb-md-0"
      >
        <b-card
          no-body
          class="h-100"
        >
          <b-card-body>
            <div class="text-muted font-small-2">
              Son run
            </div>
            <div class="font-weight-bold">
              {{ runSummaryText(latestRun) }}
            </div>
            <small class="text-muted">{{ formatDate(latestRun && latestRun.finishedAt) }}</small>
            <small
              v-if="runBalanceText(latestRun)"
              class="text-muted d-block"
            >
              {{ runBalanceText(latestRun) }}
            </small>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="3"
        class="mb-1 mb-md-0"
      >
        <b-card
          no-body
          class="h-100"
        >
          <b-card-body>
            <div class="text-muted font-small-2">
              Tarama
            </div>
            <div class="font-weight-bold">
              {{ automationOverview.scanned }} / {{ automationOverview.rawSignals }}
            </div>
            <small class="text-muted">scan / ham sinyal</small>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="3"
        class="mb-1 mb-md-0"
      >
        <b-card
          no-body
          class="h-100"
        >
          <b-card-body>
            <div class="text-muted font-small-2">
              Karar
            </div>
            <div class="font-weight-bold">
              {{ automationOverview.matched }} / {{ automationOverview.rejected }}
            </div>
            <small class="text-muted">eşleşen / reddedilen</small>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <b-card
          no-body
          class="h-100"
        >
          <b-card-body>
            <div class="text-muted font-small-2">
              Execution
            </div>
            <div class="font-weight-bold">
              {{ automationOverview.executed }} / {{ automationOverview.queued }}
            </div>
            <small class="text-muted">{{ automationOverview.executionNote }}</small>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row
      v-if="selectedRule"
      class="mb-2"
    >
      <b-col cols="12">
        <b-card no-body>
          <b-card-header class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <feather-icon
                icon="ActivityIcon"
                size="18"
                class="text-primary mr-50"
              />
              <h5 class="mb-0">
                Canlı Strateji Okuması
              </h5>
            </div>
            <b-badge :variant="strategyReading.badgeVariant">
              {{ strategyReading.modeLabel }}
            </b-badge>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col
                cols="12"
                lg="4"
                class="mb-2 mb-lg-0"
              >
                <div class="text-muted font-small-2 mb-50">
                  Strateji yorumu
                </div>
                <div
                  v-for="line in strategyReading.summary"
                  :key="line"
                  class="strategy-reading-line"
                >
                  {{ line }}
                </div>
                <b-alert
                  v-for="warning in strategyReading.warnings"
                  :key="warning"
                  show
                  variant="warning"
                  class="mt-1 mb-0"
                >
                  {{ warning }}
                </b-alert>
              </b-col>
              <b-col
                cols="12"
                lg="8"
              >
                <div class="strategy-reading-stats mb-1">
                  <div
                    v-for="item in strategyCounterRows"
                    :key="item.label"
                    class="strategy-reading-stat"
                  >
                    <small class="text-muted d-block">{{ item.label }}</small>
                    <strong>{{ item.value }}</strong>
                  </div>
                </div>
                <div
                  v-if="marketDirectionAvailable"
                  class="market-direction-panel mb-1"
                >
                  <div class="d-flex flex-wrap align-items-center justify-content-between mb-50">
                    <div>
                      <div class="text-muted font-small-2">
                        Aktif piyasa yönü tabelası
                      </div>
                      <strong>{{ marketDirectionLabel(marketDirectionSummary.direction) }}</strong>
                      <small class="text-muted d-block">
                        {{ marketDirectionSummary.reason }}
                      </small>
                    </div>
                    <b-badge :variant="marketDirectionVariant(marketDirectionSummary.direction)">
                      {{ Number(marketDirectionSummary.score || 0).toFixed(0) }} / 100
                    </b-badge>
                  </div>
                  <div class="market-direction-gauge mb-1">
                    <div
                      class="market-direction-gauge-fill"
                      :class="marketDirectionGaugeClass(marketDirectionSummary)"
                      :style="marketDirectionGaugeStyle(marketDirectionSummary.score)"
                    />
                  </div>
                  <div class="strategy-reading-stats mb-1">
                    <div class="strategy-reading-stat">
                      <small class="text-muted d-block">Coin coverage</small>
                      <strong>%{{ Number(marketDirectionSummary.coverage || 0).toFixed(0) }}</strong>
                    </div>
                    <div class="strategy-reading-stat">
                      <small class="text-muted d-block">TF coverage</small>
                      <strong>%{{ Number(marketDirectionSummary.signalCoverage || 0).toFixed(0) }}</strong>
                    </div>
                    <div class="strategy-reading-stat">
                      <small class="text-muted d-block">Fresh coverage</small>
                      <strong>%{{ Number(marketDirectionSummary.freshCoverage || 0).toFixed(0) }}</strong>
                    </div>
                    <div class="strategy-reading-stat">
                      <small class="text-muted d-block">Yön dağılımı</small>
                      <strong>L {{ marketDirectionSummary.longCoins || 0 }} / S {{ marketDirectionSummary.shortCoins || 0 }}</strong>
                    </div>
                  </div>
                  <div
                    v-for="coin in marketDirectionCoins"
                    :key="coin.symbol"
                    class="market-direction-coin"
                  >
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                      <div>
                        <strong>{{ coin.symbol }}</strong>
                        <b-badge
                          :variant="marketDirectionVariant(coin.direction)"
                          class="ml-50"
                        >
                          {{ marketDirectionLabel(coin.direction) }}
                        </b-badge>
                        <small class="text-muted d-block">
                          sinyal {{ coin.signalCount || 0 }} · fresh {{ coin.freshCount || 0 }} · TF %{{ Number(coin.timeframeCoverage || 0).toFixed(0) }}
                        </small>
                      </div>
                      <div class="d-flex align-items-center">
                        <div class="market-direction-mini mr-1">
                          <div
                            class="market-direction-mini-fill"
                            :class="marketDirectionGaugeClass(coin)"
                            :style="marketDirectionGaugeStyle(coin.score)"
                          />
                        </div>
                        <small class="text-muted mr-1">{{ Number(coin.score || 0).toFixed(0) }}</small>
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          @click="toggleMarketDirectionCoin(coin.symbol)"
                        >
                          {{ marketDirectionExpandedSymbol === coin.symbol ? 'kapat' : 'detay görüntüle' }}
                        </b-button>
                      </div>
                    </div>
                    <div
                      v-if="marketDirectionExpandedSymbol === coin.symbol"
                      class="market-direction-timeframes mt-1"
                    >
                      <div
                        v-for="tf in coin.timeframes"
                        :key="`${coin.symbol}-${tf.timeframe}`"
                        class="market-direction-timeframe"
                      >
                        <div class="d-flex justify-content-between align-items-center mb-25">
                          <strong>{{ tf.timeframe }}</strong>
                          <b-badge :variant="marketDirectionVariant(tf.direction)">
                            {{ marketDirectionLabel(tf.direction) }}
                          </b-badge>
                        </div>
                        <div class="market-direction-mini wide">
                          <div
                            class="market-direction-mini-fill"
                            :class="marketDirectionGaugeClass(tf)"
                            :style="marketDirectionGaugeStyle(tf.score)"
                          />
                        </div>
                        <small class="text-muted d-block mt-25">
                          L {{ Number(tf.longScore || 0).toFixed(0) }} / S {{ Number(tf.shortScore || 0).toFixed(0) }} · sinyal {{ tf.signalCount || 0 }}
                        </small>
                        <small class="text-muted d-block">
                          L MFE/MAE {{ formatPercentValue(tf.longMfePct) }} / {{ formatPercentValue(tf.longMaePct) }} · S MFE/MAE {{ formatPercentValue(tf.shortMfePct) }} / {{ formatPercentValue(tf.shortMaePct) }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="strategyReading.activePairDirectionRows.length"
                  class="mb-1"
                >
                  <div class="text-muted font-small-2 mb-50">
                    Aktif pozisyon yön tablosu
                  </div>
                  <b-table
                    small
                    responsive
                    class="mb-1"
                    :items="strategyReading.activePairDirectionRows"
                    :fields="activePairDirectionFields"
                    show-empty
                    empty-text="Aktif pozisyon yön satırı yok"
                  >
                    <template #cell(pair)="data">
                      <div>
                        <strong>{{ data.item.pair }}</strong>
                        <b-badge
                          class="ml-50"
                          variant="light-secondary"
                        >
                          {{ data.item.legCount || 1 }} bacak
                        </b-badge>
                        <small
                          v-if="data.item.detail"
                          class="text-muted d-block"
                        >
                          {{ data.item.detail }}
                        </small>
                      </div>
                    </template>
                    <template #cell(direction)="data">
                      <strong>{{ data.item.direction }}</strong>
                    </template>
                    <template #cell(exposure)="data">
                      <small class="text-muted">{{ data.item.exposure }}</small>
                    </template>
                    <template #cell(pnl)="data">
                      <strong :class="data.item.variant === 'success' ? 'text-success' : 'text-danger'">
                        {{ data.item.pnl }}
                      </strong>
                    </template>
                  </b-table>
                </div>
                <div class="text-muted font-small-2 mb-50">
                  Strateji muhasebesi
                </div>
                <b-table
                  v-if="strategyReading.strategyAccountingRows.length"
                  small
                  responsive
                  class="mb-1"
                  :items="strategyReading.strategyAccountingRows"
                  :fields="strategySnapshotFields"
                  show-empty
                  empty-text="Muhasebe özeti yok"
                >
                  <template #cell(label)="data">
                    <b-badge :variant="strategyAccountingBadgeVariant(data.item)">
                      {{ data.item.label }}
                    </b-badge>
                  </template>
                  <template #cell(value)="data">
                    <strong>{{ data.item.value }}</strong>
                  </template>
                  <template #cell(detail)="data">
                    <small class="text-muted">{{ data.item.detail }}</small>
                  </template>
                </b-table>
                <div
                  v-if="strategyReading.snapshotRows.length"
                  class="text-muted font-small-2 mb-50"
                >
                  Canlı snapshot
                </div>
                <b-table
                  v-if="strategyReading.snapshotRows.length"
                  small
                  responsive
                  class="mb-1"
                  :items="strategyReading.snapshotRows"
                  :fields="strategySnapshotFields"
                  show-empty
                  empty-text="Snapshot yok"
                >
                  <template #cell(label)="data">
                    <b-badge :variant="strategyAccountingBadgeVariant(data.item)">
                      {{ data.item.label }}
                    </b-badge>
                  </template>
                  <template #cell(value)="data">
                    <strong>{{ data.item.value }}</strong>
                  </template>
                  <template #cell(detail)="data">
                    <small class="text-muted">{{ data.item.detail }}</small>
                  </template>
                </b-table>
                <b-table
                  small
                  responsive
                  :items="strategyReading.accounting.rows"
                  :fields="strategyAccountingFields"
                  show-empty
                  empty-text="Muhasebe satırı yok"
                >
                  <template #cell(group)="data">
                    <b-badge variant="light-secondary">
                      {{ data.item.group }}
                    </b-badge>
                  </template>
                  <template #cell(value)="data">
                    <span :class="strategyAccountingValueClass(data.item)">
                      {{ data.item.value }}
                    </span>
                  </template>
                  <template #cell(detail)="data">
                    <small class="text-muted">{{ data.item.detail }}</small>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col
        cols="12"
        lg="4"
        class="mb-2"
      >
        <b-card
          no-body
          class="h-100"
        >
          <b-card-header>
            <h5 class="mb-0">
              Skip Reason Dağılımı
            </h5>
          </b-card-header>
          <b-card-body>
            <div
              v-if="skipReasonRows.length === 0"
              class="text-muted"
            >
              Karar verisi yok.
            </div>
            <div
              v-for="item in skipReasonRows"
              :key="item.reason"
              class="d-flex align-items-center justify-content-between border-bottom py-50"
            >
              <span>{{ reasonLabel(item.reason) }}</span>
              <b-badge variant="light-warning">
                {{ item.count }}
              </b-badge>
            </div>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col
        cols="12"
        lg="8"
        class="mb-2"
      >
        <b-card
          no-body
          class="h-100"
        >
          <b-card-header class="d-flex align-items-center justify-content-between">
            <h5 class="mb-0">
              Execution Queue / Decisions
            </h5>
            <b-button
              size="sm"
              variant="outline-primary"
              :disabled="!selectedRule"
              @click="refreshDetailTables"
            >
              <feather-icon
                icon="RefreshCwIcon"
                size="14"
              />
            </b-button>
          </b-card-header>
          <b-table
            small
            responsive
            :items="decisions"
            :fields="decisionFields"
            show-empty
            empty-text="Karar yok"
          >
            <template #cell(status)="data">
              <b-badge :variant="decisionStatusVariant(data.item.status)">
                {{ data.item.status }}
              </b-badge>
            </template>
            <template #cell(action)="data">
              <div>{{ actionLabel(data.item.action) }}</div>
              <small class="text-muted">{{ executionBridgeText(data.item) }}</small>
              <div
                v-if="profitPocketBadgeText(data.item)"
                class="mt-25"
              >
                <b-badge :variant="profitPocketVariant(data.item)">
                  {{ profitPocketBadgeText(data.item) }}
                </b-badge>
                <b-badge
                  v-if="profitPocketStrict(data.item)"
                  variant="light-info"
                  class="ml-25"
                >
                  kar şartlı
                </b-badge>
              </div>
              <div
                v-if="pairBadges(data.item).length"
                class="mt-25"
              >
                <b-badge
                  v-for="badge in pairBadges(data.item)"
                  :key="badge.text"
                  :variant="badge.variant"
                  class="mr-25 mb-25"
                >
                  {{ badge.text }}
                </b-badge>
              </div>
              <div
                v-if="balanceBadges(data.item).length"
                class="mt-25"
              >
                <b-badge
                  v-for="badge in balanceBadges(data.item)"
                  :key="badge.text"
                  :variant="badge.variant"
                  class="mr-25 mb-25"
                >
                  {{ badge.text }}
                </b-badge>
              </div>
              <small
                v-if="profitPocketDetailText(data.item)"
                class="text-muted d-block"
              >
                {{ profitPocketDetailText(data.item) }}
              </small>
              <small
                v-if="pairDetailText(data.item)"
                class="text-muted d-block"
              >
                {{ pairDetailText(data.item) }}
              </small>
              <small
                v-if="balanceDetailText(data.item)"
                class="text-muted d-block"
              >
                {{ balanceDetailText(data.item) }}
              </small>
            </template>
            <template #cell(symbol)="data">
              <strong>{{ data.item.symbol }}</strong>
              <div class="font-small-2 text-muted">
                {{ data.item.timeframe }} · {{ data.item.side }}
              </div>
            </template>
            <template #cell(bot)="data">
              <span>{{ data.item.botId ? ('bot #' + data.item.botId) : '—' }}</span>
              <div
                v-if="data.item.positionId"
                class="font-small-2 text-muted"
              >
                pozisyon #{{ data.item.positionId }}
              </div>
            </template>
            <template #cell(reason)="data">
              <div>{{ reasonLabel(data.item.skipReason) }}</div>
              <small class="text-muted">{{ compactReasons(data.item.reasons) }}</small>
            </template>
            <template #cell(ops)="data">
              <b-button
                v-if="canExecuteCloseDecision(data.item)"
                size="sm"
                variant="outline-danger"
                :disabled="closeApproval.busy"
                @click="openCloseApproval(data.item)"
              >
                Çalıştır
              </b-button>
              <span
                v-else
                class="text-muted"
              >—</span>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      id="close-approval-modal"
      title="Close kararını çalıştır"
      :ok-title="closeApprovalOkTitle"
      cancel-title="Vazgeç"
      ok-variant="danger"
      :ok-disabled="closeApproval.busy || closeApprovalLiveBlocked"
      @ok.prevent="executeCloseApproval"
      @hidden="resetCloseApproval"
    >
      <div v-if="closeApproval.item">
        <h6 class="mb-50">
          {{ closeApproval.item.symbol }} · {{ closeApproval.item.timeframe }} · {{ closeApproval.item.side }}
        </h6>
        <div class="text-muted mb-1">
          bot #{{ closeApproval.item.botId }} · pozisyon #{{ closeApproval.item.positionId }}
        </div>
        <b-row>
          <b-col
            cols="6"
            class="mb-1"
          >
            <small class="text-muted">Karar</small>
            <div>{{ actionLabel(closeApproval.item.action) }}</div>
          </b-col>
          <b-col
            cols="6"
            class="mb-1"
          >
            <small class="text-muted">Tahmini PnL</small>
            <div>{{ profitPocketPnlText(closeApproval.item) }}</div>
          </b-col>
          <b-col
            cols="6"
            class="mb-1"
          >
            <small class="text-muted">Tip</small>
            <div>{{ profitPocketTypeText(closeApproval.item) }}</div>
          </b-col>
          <b-col
            cols="6"
            class="mb-1"
          >
            <small class="text-muted">Bütçe hedefi</small>
            <div>{{ profitPocketTargetText(closeApproval.item) }}</div>
          </b-col>
          <b-col
            v-if="closeApprovalPartialText(closeApproval.item)"
            cols="12"
            class="mb-1"
          >
            <small class="text-muted">Parçalı close</small>
            <div>{{ closeApprovalPartialText(closeApproval.item) }}</div>
          </b-col>
        </b-row>
        <b-alert
          v-if="closeApprovalMode(closeApproval.item) === 'LIVE'"
          show
          variant="warning"
          class="mt-1"
        >
          LIVE close gerçek emir gönderebilir. Çalıştırmak için iki onay da gerekli.
        </b-alert>
        <b-form-checkbox
          v-if="closeApprovalMode(closeApproval.item) === 'LIVE'"
          v-model="closeApproval.liveConfirm"
          switch
          class="mb-50"
        >
          LIVE close onayı veriyorum
        </b-form-checkbox>
        <b-form-checkbox
          v-if="closeApprovalMode(closeApproval.item) === 'LIVE'"
          v-model="closeApproval.acknowledgeLiveCloseRisk"
          switch
        >
          Risk etkisini anladım
        </b-form-checkbox>
      </div>
    </b-modal>

    <b-card no-body>
      <b-card-header>
        <h5 class="mb-0">
          Run History
        </h5>
      </b-card-header>
      <b-table
        small
        responsive
        :items="runs"
        :fields="runFields"
        show-empty
        empty-text="Run yok"
      >
        <template #cell(status)="data">
          <b-badge :variant="runStatusVariant(data.item.status)">
            {{ data.item.status }}
          </b-badge>
        </template>
        <template #cell(counts)="data">
          scan {{ data.item.scannedCount }} · match {{ data.item.matchedCount }} · queue {{ data.item.queuedCount }} · assigned {{ data.item.assignedCount }} · executed {{ data.item.executedCount }} · reject {{ data.item.rejectedCount }}
        </template>
        <template #cell(detail)="data">
          <span>{{ runSummaryText(data.item) }}</span>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BAlert,
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BModal,
  BRow,
  BTab,
  BTable,
  BTabs,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import {
  buildSignalAutomationLiveStrategyReading,
  reasonLabel as strategyReasonLabel,
} from '@/utils/signalAutomationStrategyReading'

export default {
  name: 'SignalAutomationIndex',
  components: {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BCol,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormSelect,
    BInputGroup,
    BInputGroupAppend,
    BModal,
    BRow,
    BTab,
    BTable,
    BTabs,
  },
  data() {
    return {
      search: '',
      saving: false,
      adaptiveTpSlApplying: false,
      selectedRule: null,
      form: this.emptyForm(),
      closeApproval: {
        item: null,
        busy: false,
        liveConfirm: false,
        acknowledgeLiveCloseRisk: false,
      },
      marketDirectionExpandedSymbol: null,
      ruleFields: [
        { key: 'name', label: 'Kural' },
        { key: 'enabled', label: 'Durum' },
        { key: 'policy', label: 'Policy' },
      ],
      decisionFields: [
        { key: 'status', label: 'Durum' },
        { key: 'action', label: 'Aksiyon' },
        { key: 'symbol', label: 'Sinyal' },
        { key: 'bot', label: 'Bot / Pozisyon' },
        { key: 'reason', label: 'Sebep' },
        { key: 'createdAt', label: 'Zaman', formatter: this.formatDate },
        { key: 'ops', label: 'İşlem' },
      ],
      runFields: [
        { key: 'status', label: 'Durum' },
        { key: 'triggerSource', label: 'Tetik' },
        { key: 'counts', label: 'Özet' },
        { key: 'detail', label: 'Not' },
        { key: 'startedAt', label: 'Başlangıç', formatter: this.formatDate },
        { key: 'finishedAt', label: 'Bitiş', formatter: this.formatDate },
      ],
      strategyAccountingFields: [
        { key: 'group', label: 'Grup' },
        { key: 'label', label: 'Hesap' },
        { key: 'value', label: 'Değer' },
        { key: 'detail', label: 'Detay' },
      ],
      strategySnapshotFields: [
        { key: 'label', label: 'Snapshot' },
        { key: 'value', label: 'Durum' },
        { key: 'detail', label: 'Detay' },
      ],
      activePairDirectionFields: [
        { key: 'pair', label: 'Çift / Pozisyon' },
        { key: 'direction', label: 'Yön skoru' },
        { key: 'exposure', label: 'Margin / Kaldıraç' },
        { key: 'pnl', label: 'PnL' },
      ],
      scopeOptions: [
        { value: 'TARGET_SCOPED', text: 'Hedefe bağlı' },
        { value: 'ACCOUNT_SCOPED', text: 'Hesap geneli' },
      ],
      coinPoolTfModeOptions: [
        { value: 'FIXED_POOL', text: 'Sabit Coin havuzu ve TF' },
        { value: 'EDGE_LIBRARY', text: 'Edge Library' },
      ],
      edgeKindOptions: [
        { value: null, text: 'Tüm edge tipleri' },
        { value: 'NORMAL', text: 'Normal' },
        { value: 'QUICK_GAIN', text: 'Quick Gain' },
      ],
      marketOptions: [
        { value: 'FUTURES', text: 'Futures' },
        { value: 'SPOT', text: 'Spot' },
      ],
      modeOptions: [
        { value: 'TESTNET', text: 'Testnet' },
        { value: 'LIVE', text: 'Canlı' },
      ],
      executionOptions: [
        { value: 'REQUIRE_APPROVAL', text: 'Onay iste' },
        { value: 'AUTO_ASSIGN_ONLY', text: 'Sadece bot ata' },
        { value: 'AUTO_PROTECT_ONLY', text: 'Sadece koruma' },
        { value: 'AUTO_EXECUTE_WITH_LIMITS', text: 'Limitlerle otomatik' },
      ],
      botSelectionOptions: [
        { value: 'USE_AVAILABLE', text: 'Müsait bot kullan' },
        { value: 'CREATE_IF_NEEDED', text: 'Gerekirse bot oluştur' },
        { value: 'REUSE_OR_CREATE', text: 'Kullan veya oluştur' },
      ],
      lateRiskOptions: [
        { value: 'LOW', text: 'Düşük' },
        { value: 'MEDIUM', text: 'Orta' },
        { value: 'HIGH', text: 'Yüksek' },
      ],
      balanceGovernorModeOptions: [
        { value: 'STRICT', text: 'Sıkı' },
        { value: 'BALANCED', text: 'Dengeli' },
        { value: 'FLEXIBLE', text: 'Esnek' },
      ],
      balanceGovernorOddSlotOptions: [
        { value: 'WAIT', text: 'Bekle' },
        { value: 'TRY_PROFIT_POCKET_UNLOCK', text: 'Kar sepetiyle slot açmayı dene' },
        { value: 'SUGGEST_EXTRA_SLOT', text: '+1 slot öner' },
      ],
      balanceGovernorTransmissionModeOptions: [
        { value: 'SEQUENTIAL', text: 'Sıralı' },
        { value: 'GRADUAL', text: 'Kademeli' },
        { value: 'ALL_SLOTS', text: 'Tüm slotlar' },
      ],
      balanceGovernorTransferModeOptions: [
        { value: 'REALTIME', text: 'Anlık transfer' },
        { value: 'POST_CLOSE', text: 'İşlem sonrası transfer' },
      ],
      balanceGovernorTransferActionOptions: [
        { value: 'ADD_MARGIN_ONLY', text: 'Margin ekle (güvenli)' },
        { value: 'SCALE_IN_POSITION', text: 'Mevcut poza ekle' },
        { value: 'OPEN_NEW_SLOT', text: 'Boş slot doldur' },
      ],
      balanceGovernorSafeCloseModeOptions: [
        { value: 'UNTARGETED', text: 'Hedefsiz kapatma' },
        { value: 'TARGETED', text: 'Hedefli kapatma' },
      ],
      balanceGovernorPairCloseCompanionModeOptions: [
        { value: 'PARTIAL_REBALANCE', text: 'Rebalance zarar % kadar kapat' },
        { value: 'FULL_CLOSE', text: 'Karşı pozisyonu tamamen kapat' },
      ],
      balanceGovernorLowScoreUncertainSwapMarketModeOptions: [
        { value: 'RANGE_MIXED', text: 'Range / Karışık' },
        { value: 'RANGE', text: 'Sadece range' },
        { value: 'MIXED', text: 'Sadece karışık' },
      ],
      balanceGovernorAutoManageTransmissionTriggerModeOptions: [
        { value: 'PNL_PERCENT', text: 'PnL yüzdesi' },
        { value: 'CLOSED_TRADES', text: 'Toplam kapanış adedi' },
      ],
      transmissionLevelFields: [
        { key: 'level', label: 'Seviye' },
        { key: 'longLeverage', label: 'LONG kaldıraç' },
        { key: 'shortLeverage', label: 'SHORT kaldıraç' },
        { key: 'longMargin', label: 'LONG margin %' },
        { key: 'shortMargin', label: 'SHORT margin %' },
        { key: 'autoIncrease', label: 'Seviye artış %' },
      ],
      profitLossCleanupModeOptions: [
        { value: 'SINGLE_POSITION', text: 'Single Position' },
        { value: 'TOTAL_POSITIVE_PNL', text: 'Total Positive PnL' },
      ],
      realizedProfitDistributionTimingOptions: [
        { value: 'ACTIVE_AND_CLOSED_BUDGET', text: 'Aktif pozisyona margin ekle ve kapalı olanların bütçelerine dahil et' },
        { value: 'NEW_POSITION_BUDGET', text: 'Yeni pozisyonların bütçelerine ekle' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      dataList: 'signalAutomation/dataList',
      loading: 'signalAutomation/loading',
      runs: 'signalAutomation/runs',
      decisions: 'signalAutomation/decisions',
      dataSaveStatus: 'signalAutomation/dataSaveStatus',
    }),
    skipReasonRows() {
      const map = {}
      const rows = this.decisions || []
      rows.forEach(item => {
        const reason = item.skipReason || 'NO_SKIP_REASON'
        map[reason] = (map[reason] || 0) + 1
      })
      return Object.keys(map)
        .map(reason => ({ reason, count: map[reason] }))
        .sort((a, b) => b.count - a.count)
    },
    latestRun() {
      return (this.runs || [])[0] || null
    },
    apiKeyOptions() {
      const list = this.$store.getters['apiKeys/dataList'] || []
      return [
        { value: null, text: 'API key seç' },
        ...list.filter(item => item.isActive).map(item => ({
          value: item.id,
          text: `${item.provider ? item.provider.name : '?'} · ${item.label || '(etiketsiz)'}`,
        })),
      ]
    },
    automationOverview() {
      const run = this.latestRun || {}
      const summary = this.safeObject(run.summary)
      const scan = this.safeObject(summary.scanSummary)
      const execution = this.safeObject(summary.executionSummary)
      return {
        scanned: Number(run.scannedCount || 0),
        rawSignals: Number(scan.rawSignals || 0),
        matched: Number(run.matchedCount || 0),
        rejected: Number(run.rejectedCount || 0),
        queued: Number(run.queuedCount || 0),
        assigned: Number(run.assignedCount || 0),
        executed: Number(run.executedCount || 0),
        skipped: Number(run.skippedCount || 0),
        executionNote: this.executionSummaryNote(execution),
      }
    },
    closeApprovalLiveBlocked() {
      const { item, liveConfirm, acknowledgeLiveCloseRisk } = this.closeApproval
      if (!item || this.closeApprovalMode(item) !== 'LIVE') return false
      return !(liveConfirm && acknowledgeLiveCloseRisk)
    },
    closeApprovalOkTitle() {
      return this.closeApproval.item && this.closeApproval.item.action === 'PARTIAL_CLOSE_EXISTING'
        ? 'Partial close çalıştır'
        : 'Close çalıştır'
    },
    strategyReading() {
      const draftRule = this.selectedRule ? this.buildRuleBody() : {}
      const summary = this.safeObject(this.safeObject(this.latestRun).summary)
      const profitPocketSummary = this.safeObject(summary.profitPocketSummary)
      return buildSignalAutomationLiveStrategyReading({
        rule: {
          ...(this.selectedRule || {}),
          ...draftRule,
          id: this.selectedRule && this.selectedRule.id,
        },
        form: this.form,
        latestRun: this.latestRun,
        decisions: this.decisions,
        targetBudgetUsdt: profitPocketSummary.budgetBaseUsdt,
      })
    },
    strategyCounterRows() {
      const counters = this.strategyReading.counters || {}
      return [
        { label: 'Scan / Match', value: `${counters.scanned || 0} / ${counters.matched || 0}` },
        { label: 'Queue / Assign', value: `${counters.queued || 0} / ${counters.assigned || 0}` },
        { label: 'Execute / Skip', value: `${counters.executed || 0} / ${counters.skipped || 0}` },
        { label: 'Reject', value: counters.rejected || 0 },
      ]
    },
    marketDirectionSummary() {
      const summary = this.safeObject(this.safeObject(this.latestRun).summary)
      return this.safeObject(summary.marketDirectionSummary)
    },
    marketDirectionCoins() {
      const coins = Array.isArray(this.marketDirectionSummary.coins)
        ? this.marketDirectionSummary.coins
        : []
      return [...coins].sort((a, b) => Number(b.score || 0) - Number(a.score || 0))
    },
    marketDirectionAvailable() {
      return this.marketDirectionSummary.enabled === true && this.marketDirectionCoins.length > 0
    },
    maxTransmissionLeverage() {
      return Math.max(1, Math.round(Number(this.form.leverage || 1)))
    },
    transmissionLevelRows() {
      return [1, 2, 3, 4].map(level => ({ level: `Seviye ${level}` }))
    },
  },
  created() {
    this.fetchList()
    if (!this.$store.getters['apiKeys/dataList']?.length) {
      this.$store.dispatch('apiKeys/getDataList', {})
    }
  },
  methods: {
    formatPercentValue(value) {
      const numeric = Number(value)
      return Number.isFinite(numeric) ? `%${numeric.toFixed(2)}` : '-'
    },
    emptyForm() {
      return {
        id: null,
        name: 'Yeni sinyal otomasyonu',
        enabled: false,
        scope: 'TARGET_SCOPED',
        targetId: null,
        engineKey: 'triple-ma-forecast-signals-v1.1',
        market: 'FUTURES',
        coinPoolTfMode: 'FIXED_POOL',
        timeframesText: '30m,1h,4h',
        coinsText: '',
        edgeKind: null,
        topNEdges: 20,
        useEdgeTimeframes: false,
        marketScoreGateMin: 0,
        marketScoreGateMax: 100,
        sideLong: true,
        sideShort: true,
        minScore: 0.7,
        minConfidence: 0.6,
        maxSignalAgeBars: 3,
        maxSignalAgeMinutes: 180,
        maxMaePct: null,
        minMfePct: null,
        blockDuplicateSignal: true,
        blockSameSymbolOpenPosition: true,
        executionMode: 'TESTNET',
        apiKeyId: null,
        acknowledgeLiveExecutionRisk: false,
        botSelectionMode: 'USE_AVAILABLE',
        maxBotsToCreate: 0,
        maxSameSymbolPositions: 1,
        budgetEnabled: true,
        dailyMaxNewPositions: 3,
        maxOpenPositions: 3,
        maxPerPositionMarginUsdt: 0,
        tpPerc: 2.5,
        slPerc: 1,
        leverage: 10,
        commissionPerSide: 0.05,
        adaptiveTpSlSynchronizerEnabled: false,
        adaptiveTpSlKeepProfitMarginEnabled: true,
        adaptiveTpSlMaeCutPercent: 25,
        adaptiveTpSlMfePercentile: 65,
        adaptiveTpSlMaePercentile: 75,
        adaptiveTpSlRollingWindowRuns: 6,
        adaptiveTpSlMaxTpPerc: 10,
        adaptiveTpSlMaxSlPerc: 5,
        adaptiveTpSlSymbolAdaptationEnabled: false,
        adaptiveTpSlSymbolWeightPercent: 50,
        adaptiveTpSlAlignProfitLossCleanupEnabled: false,
        adaptiveTpSlProfitLossCleanupBandPercent: 60,
        adaptiveTpSlSyncOpportunityControlsEnabled: false,
        adaptiveTpSlPreviousTpPerc: null,
        adaptiveTpSlPreviousSlPerc: null,
        adaptiveTpSlCurrentMfePct: null,
        adaptiveTpSlCurrentMaePct: null,
        adaptiveTpSlPreviousMfePct: null,
        adaptiveTpSlPreviousMaePct: null,
        pairBalancedEntriesEnabled: false,
        pairHedgeOnlyEnabled: false,
        pairImmediateHedgeRefillEnabled: false,
        pairSuitableCoinsEnabled: false,
        pairMinScore: null,
        pairMinConfidence: null,
        pairMaxLateEntryRisk: 'MEDIUM',
        pairBlockExhaustedDecay: true,
        pairUnlockWithProfitBasket: true,
        pairSuggestExtraSlotWhenLocked: true,
        longShortBalanceEnabled: false,
        maxDirectionalBiasPct: 70,
        balanceGovernorEnabled: false,
        balanceGovernorMode: 'BALANCED',
        balanceGovernorMaxSideGap: 1,
        balanceGovernorOddSlotPolicy: 'TRY_PROFIT_POCKET_UNLOCK',
        balanceGovernorPreferEntries: true,
        balanceGovernorPreferLossOffset: true,
        balanceGovernorRecomputeAfterClose: true,
        balanceGovernorBlockWhenImbalanced: true,
        balanceGovernorRebalanceProtectionEnabled: false,
        balanceGovernorRebalanceProtectionGraceMinutes: 5,
        balanceGovernorRebalanceProtectionMaxLossPct: 0.35,
        balanceGovernorRebalanceProtectionMaxClosesPerRun: 1,
        balanceGovernorSequentialDamageTrimEnabled: false,
        balanceGovernorSequentialDamageTrimClosePercent: 25,
        balanceGovernorPairScopedLossOffsetEnabled: false,
        balanceGovernorPairCloseCompanionEnabled: false,
        balanceGovernorPairCloseCompanionMode: 'PARTIAL_REBALANCE',
        balanceGovernorTransmissionMode: 'SEQUENTIAL',
        balanceGovernorGradualTransmissionTriggerPnlPercent: 0.2,
        balanceGovernorTransmissionFallbackEnabled: true,
        balanceGovernorTransmissionFallbackWaitMinutes: 30,
        balanceGovernorInitialTransmissionLevel: 4,
        balanceGovernorStartTransmissionFromActiveLevels: false,
        balanceGovernorStableDirectionRunsRequired: 2,
        balanceGovernorCounterSideLevelStepDown: 0.5,
        balanceGovernorMarketTableConfirmationStep: 0.5,
        balanceGovernorLowScoreUncertainSwapEnabled: false,
        balanceGovernorLowScoreUncertainSwapMaxScore: 40,
        balanceGovernorLowScoreUncertainSwapMarketMode: 'RANGE_MIXED',
        balanceGovernorCruiseControlEnabled: false,
        balanceGovernorReversalGuardEnabled: true,
        balanceGovernorSteeringModeMfe: false,
        balanceGovernorMfeMomentumQualityMin: 0.3,
        balanceGovernorTransferMode: 'REALTIME',
        balanceGovernorTransferAction: 'ADD_MARGIN_ONLY',
        balanceGovernorAutoManageTransmissionLevelsEnabled: false,
        balanceGovernorAutoManageTransmissionTriggerMode: 'PNL_PERCENT',
        balanceGovernorAutoManageTransmissionRealizedProfitTriggerPct: 0.5,
        balanceGovernorAutoManageTransmissionClosedTradesTriggerCount: 100,
        balanceGovernorAutoManageTransmissionLevelIncreasePercents: [10, 10, 10, 10],
        balanceGovernorAutoManageTransmissionLastAppliedStep: 0,
        balanceGovernorAutoManageTransmissionBaseLeverageLevels: null,
        balanceGovernorAutoManageTransmissionBaseMarginLevelPercents: null,
        balanceGovernorAutoResetBalancesEnabled: false,
        balanceGovernorAutoResetIntervalEnabled: false,
        balanceGovernorAutoResetIntervalMinutes: 60,
        balanceGovernorAutoResetUnrealizedProfitEnabled: false,
        balanceGovernorAutoResetUnrealizedProfitPct: 0.5,
        balanceGovernorAutoResetCloseAgedPairEnabled: false,
        balanceGovernorAutoResetCloseAgedPairMinutes: 120,
        balanceGovernorAutoResetUnrealizedVsRealizedEnabled: false,
        balanceGovernorAutoResetUnrealizedVsRealizedPct: 50,
        balanceGovernorAutoResetFakeProfitProtectionEnabled: true,
        balanceGovernorAutoResetLastAt: null,
        balanceGovernorPairWinnerTrailingEnabled: false,
        balanceGovernorPairWinnerTrailingTriggerPnlPct: 1.5,
        balanceGovernorPairWinnerTrailingOffsetPnlPct: 0.6,
        balanceGovernorHedgePairLifecycleEnabled: false,
        balanceGovernorHedgePairWinnerMinPnlPercent: 0.18,
        balanceGovernorHedgePairWinnerMinNetUsdt: 0,
        balanceGovernorHedgePairWinnerConfirmRuns: 2,
        balanceGovernorHedgePairWinnerMfeMaeConfirmEnabled: true,
        balanceGovernorHedgePairWinnerMfeMaeMinRatio: 1.2,
        balanceGovernorHedgePairLoserFirstTrimPercent: 25,
        balanceGovernorHedgePairLoserSecondTrimPercent: 25,
        balanceGovernorHedgePairMaxTrimCount: 2,
        balanceGovernorHedgePairMaxLoserTrimPerRun: 1,
        balanceGovernorHedgePairLoserMinLossPercent: 0.1,
        balanceGovernorHedgePairWinnerProfitUsablePercent: 60,
        balanceGovernorHedgePairUseRealizedBuffer: true,
        balanceGovernorHedgePairUseUnrealizedWinnerAssist: true,
        balanceGovernorHedgePairActivateWinnerTrailingOnTrim: true,
        balanceGovernorHedgePairWinnerTrailingTriggerPnlPct: 0.2,
        balanceGovernorHedgePairWinnerTrailingOffsetPnlPct: 0.08,
        balanceGovernorHedgePairProtectWinnerFromGeneralCleanup: true,
        balanceGovernorHedgePairOnlySamePairCleanup: true,
        balanceGovernorHedgePairBlockGenericLossOffsetWhileManaged: true,
        balanceGovernorLongLeverageLevels: [10, 15, 20, 30],
        balanceGovernorShortLeverageLevels: [10, 15, 20, 30],
        balanceGovernorLongMarginLevelPercents: [25, 50, 75, 100],
        balanceGovernorShortMarginLevelPercents: [25, 50, 75, 100],
        balanceGovernorSafeCloseEnabled: false,
        balanceGovernorSafeCloseMode: 'UNTARGETED',
        balanceGovernorSafeCloseRealizedProfitTargetUsdt: 0,
        balanceGovernorSafeCloseMaxProfitGivebackPercent: 50,
        executionPolicy: 'REQUIRE_APPROVAL',
        allowOpenNewPosition: false,
        allowProtectExisting: true,
        allowCloseAndOpenNew: false,
        indicatorExitSignalEnabled: true,
        immediateBotAssignmentEnabled: false,
        minOpportunityScoreDelta: 0.15,
        maxLateEntryRisk: 'MEDIUM',
        harvestProfitablePositions: false,
        harvestScopeBot: false,
        harvestBudgetPct: 10,
        profitCloseMinPnlPct: 0,
        lossOffsetCloseEnabled: false,
        requireProfitHarvestForLossOffset: false,
        lossOffsetProfitMultipleEnabled: false,
        lossOffsetProfitMultiple: 1,
        lossOffsetMinLossPct: 0,
        lossOffsetLargestFirst: true,
        partialLossCloseEnabled: false,
        partialLossCloseAllEligible: false,
        partialLossCloseThresholdEnabled: false,
        partialLossCloseThresholdPnlPct: 0,
        partialLossClosePercent: 25,
        maxPartialLossOffsetsPerRun: 1,
        timedLossOffsetEnabled: false,
        timedLossOffsetIntervalMinutes: 60,
        timedLossOffsetMinLossPct: 0,
        timedLossOffsetProfitSharePct: 100,
        rapidLossCloseEnabled: false,
        rapidLossCloseWindowMinutes: 10,
        rapidLossCloseMinLossPct: 0.75,
        maxRapidLossClosesPerRun: 1,
        profitLossCleanupEnabled: false,
        profitLossCleanupMode: 'SINGLE_POSITION',
        profitLossCleanupMinimumPnlPercent: 0.8,
        profitLossCleanupPercent: 75,
        profitLossCleanupPartialLossEnabled: false,
        distributeRealizedProfitToPositionsEnabled: false,
        realizedProfitDistributionTiming: 'ACTIVE_AND_CLOSED_BUDGET',
        realizedProfitDistributionSharePct: 30,
        realizedProfitDistributionReservePct: 50,
        realizedProfitDistributionSafetyPct: 20,
        realizedProfitDistributionMaxSlRiskBufferPct: 50,
        realizedProfitDistributionMaxExtraPerPositionUsdt: 25,
        realizedProfitDistributionMaxBudgetMultiplier: 2,
        realizedProfitDistributionMinProfitUsdt: 0,
        scheduleEnabled: false,
        intervalMinutes: 5,
        cooldownMinutes: 0,
        timeoutSeconds: 60,
        runAfterRescan: true,
        hedgePairTradingPanelEnabled: false,
      }
    },
    fetchList() {
      return this.$store.dispatch('signalAutomation/getDataList', {
        search: this.search || undefined,
        page: 1,
        limit: 50,
      })
    },
    newRule() {
      this.selectedRule = null
      this.form = this.emptyForm()
      this.$store.commit('signalAutomation/SET_RUNS', [])
      this.$store.commit('signalAutomation/SET_DECISIONS', [])
    },
    selectRule(rule) {
      this.selectedRule = rule
      this.form = this.formFromRule(rule)
      this.refreshDetailTables()
    },
    refreshDetailTables() {
      if (!this.selectedRule) return Promise.resolve()
      return Promise.all([
        this.$store.dispatch('signalAutomation/getRuns', this.selectedRule.id),
        this.$store.dispatch('signalAutomation/getDecisions', this.selectedRule.id),
      ])
    },
    saveRule() {
      this.saving = true
      const body = this.buildRuleBody()
      const action = this.form.id
        ? this.$store.dispatch('signalAutomation/update', { id: this.form.id, body })
        : this.$store.dispatch('signalAutomation/create', body)
      return action
        .then(rule => {
          this.selectedRule = rule
          this.form = this.formFromRule(rule)
          return this.refreshDetailTables().then(() => rule)
        })
        .finally(() => {
          this.saving = false
        })
    },
    applyAdaptiveTpSlNow() {
      if (!this.form.id || !this.form.adaptiveTpSlSynchronizerEnabled) return Promise.resolve()
      this.adaptiveTpSlApplying = true
      return this.saveRule()
        .then(rule => this.$store.dispatch('signalAutomation/applyAdaptiveTpSl', rule.id))
        .then(result => {
          if (result && result.rule) {
            this.selectedRule = result.rule
            this.form = this.formFromRule(result.rule)
          }
          return this.refreshDetailTables()
        })
        .finally(() => {
          this.adaptiveTpSlApplying = false
        })
    },
    archiveRule() {
      if (!this.selectedRule) return Promise.resolve()
      return this.$store.dispatch('signalAutomation/remove', this.selectedRule.id)
        .then(() => {
          this.newRule()
        })
    },
    formFromRule(rule) {
      const source = rule.source || {}
      const filters = rule.filters || {}
      const assignment = rule.assignment || {}
      const budget = rule.budget || {}
      const runtimeConfig = rule.runtimeConfig || {}
      const opportunityPolicy = rule.opportunityPolicy || {}
      const balanceGovernor = rule.balanceGovernor || {}
      const schedule = rule.schedule || {}
      const sides = filters.sides || ['LONG', 'SHORT']
      const coinUniverse = source.coinUniverse || {}
      const timeframes = source.timeframes || []
      return {
        ...this.emptyForm(),
        id: rule.id,
        name: rule.name,
        enabled: Boolean(rule.enabled),
        scope: rule.scope || assignment.scope || 'TARGET_SCOPED',
        targetId: rule.targetId || assignment.targetId || null,
        engineKey: rule.engineKey || source.engineKey || '',
        market: rule.market || source.market || 'FUTURES',
        coinPoolTfMode: coinUniverse.source === 'EDGE_LIBRARY' ? 'EDGE_LIBRARY' : 'FIXED_POOL',
        timeframesText: timeframes.join(','),
        coinsText: (coinUniverse.coins || []).join(','),
        edgeKind: coinUniverse.edgeKind || null,
        topNEdges: coinUniverse.topNEdges || coinUniverse.topNCoins || 20,
        useEdgeTimeframes: coinUniverse.useEdgeTimeframes === true,
        marketScoreGateMin: source.marketScoreGateMin === 0 ? 0 : source.marketScoreGateMin || 0,
        marketScoreGateMax: source.marketScoreGateMax === 0 ? 0 : source.marketScoreGateMax || 100,
        sideLong: sides.includes('LONG'),
        sideShort: sides.includes('SHORT'),
        minScore: filters.minScore,
        minConfidence: filters.minConfidence,
        maxSignalAgeBars: filters.maxSignalAgeBars,
        maxSignalAgeMinutes: filters.maxSignalAgeMinutes,
        maxMaePct: filters.maxMaePct,
        minMfePct: filters.minMfePct,
        blockDuplicateSignal: filters.blockDuplicateSignal !== false,
        blockSameSymbolOpenPosition: filters.blockSameSymbolOpenPosition !== false,
        executionMode: assignment.executionMode || 'TESTNET',
        apiKeyId: assignment.apiKeyId || null,
        acknowledgeLiveExecutionRisk: assignment.acknowledgeLiveExecutionRisk === true,
        botSelectionMode: assignment.botSelectionMode || 'USE_AVAILABLE',
        maxBotsToCreate: assignment.maxBotsToCreate || 0,
        maxSameSymbolPositions: assignment.maxSameSymbolPositions || budget.maxSameSymbolPositions || 1,
        pairBalancedEntriesEnabled: assignment.pairBalancedEntriesEnabled === true,
        pairHedgeOnlyEnabled: assignment.pairHedgeOnlyEnabled === true,
        pairImmediateHedgeRefillEnabled: assignment.pairImmediateHedgeRefillEnabled === true,
        pairSuitableCoinsEnabled: assignment.pairSuitableCoinsEnabled === true,
        pairMinScore: assignment.pairMinScore,
        pairMinConfidence: assignment.pairMinConfidence,
        pairMaxLateEntryRisk: assignment.pairMaxLateEntryRisk || 'MEDIUM',
        pairBlockExhaustedDecay: assignment.pairBlockExhaustedDecay !== false,
        pairUnlockWithProfitBasket: assignment.pairUnlockWithProfitBasket !== false,
        pairSuggestExtraSlotWhenLocked: assignment.pairSuggestExtraSlotWhenLocked !== false,
        budgetEnabled: budget.enabled !== false,
        dailyMaxNewPositions: budget.dailyMaxNewPositions || 3,
        maxOpenPositions: budget.maxOpenPositions || 3,
        maxPerPositionMarginUsdt: budget.maxPerPositionMarginUsdt || 0,
        tpPerc: runtimeConfig.tpPerc || 2.5,
        slPerc: runtimeConfig.slPerc || 1,
        leverage: runtimeConfig.leverage || 10,
        commissionPerSide: runtimeConfig.commissionPerSide || 0.05,
        adaptiveTpSlSynchronizerEnabled: runtimeConfig.adaptiveTpSlSynchronizerEnabled === true,
        adaptiveTpSlKeepProfitMarginEnabled: runtimeConfig.adaptiveTpSlKeepProfitMarginEnabled !== false,
        adaptiveTpSlMaeCutPercent: runtimeConfig.adaptiveTpSlMaeBufferPercent === 0 || runtimeConfig.adaptiveTpSlMaeCutPercent === 0
          ? 0
          : runtimeConfig.adaptiveTpSlMaeBufferPercent || runtimeConfig.adaptiveTpSlMaeCutPercent || 25,
        adaptiveTpSlMfePercentile: runtimeConfig.adaptiveTpSlMfePercentile || 65,
        adaptiveTpSlMaePercentile: runtimeConfig.adaptiveTpSlMaePercentile || 75,
        adaptiveTpSlRollingWindowRuns: runtimeConfig.adaptiveTpSlRollingWindowRuns || 6,
        adaptiveTpSlMaxTpPerc: runtimeConfig.adaptiveTpSlMaxTpPerc || 10,
        adaptiveTpSlMaxSlPerc: runtimeConfig.adaptiveTpSlMaxSlPerc || 5,
        adaptiveTpSlSymbolAdaptationEnabled: runtimeConfig.adaptiveTpSlSymbolAdaptationEnabled === true,
        adaptiveTpSlSymbolWeightPercent: runtimeConfig.adaptiveTpSlSymbolWeightPercent === 0
          ? 0
          : runtimeConfig.adaptiveTpSlSymbolWeightPercent || 50,
        adaptiveTpSlAlignProfitLossCleanupEnabled: runtimeConfig.adaptiveTpSlAlignProfitLossCleanupEnabled === true,
        adaptiveTpSlProfitLossCleanupBandPercent: runtimeConfig.adaptiveTpSlProfitLossCleanupBandPercent === 0
          ? 0
          : runtimeConfig.adaptiveTpSlProfitLossCleanupBandPercent || 60,
        adaptiveTpSlSyncOpportunityControlsEnabled: runtimeConfig.adaptiveTpSlSyncOpportunityControlsEnabled === true,
        adaptiveTpSlPreviousTpPerc: runtimeConfig.adaptiveTpSlPreviousTpPerc || null,
        adaptiveTpSlPreviousSlPerc: runtimeConfig.adaptiveTpSlPreviousSlPerc || null,
        adaptiveTpSlCurrentMfePct: runtimeConfig.adaptiveTpSlCurrentMfePct || null,
        adaptiveTpSlCurrentMaePct: runtimeConfig.adaptiveTpSlCurrentMaePct || null,
        adaptiveTpSlPreviousMfePct: runtimeConfig.adaptiveTpSlPreviousMfePct || null,
        adaptiveTpSlPreviousMaePct: runtimeConfig.adaptiveTpSlPreviousMaePct || null,
        longShortBalanceEnabled: budget.longShortBalanceEnabled === true,
        maxDirectionalBiasPct: budget.maxDirectionalBiasPct || 70,
        balanceGovernorEnabled: balanceGovernor.enabled === true,
        balanceGovernorMode: balanceGovernor.mode || 'BALANCED',
        balanceGovernorMaxSideGap: balanceGovernor.maxSideGap === 0 ? 0 : balanceGovernor.maxSideGap || 1,
        balanceGovernorOddSlotPolicy: balanceGovernor.oddSlotPolicy || 'TRY_PROFIT_POCKET_UNLOCK',
        balanceGovernorPreferEntries: balanceGovernor.preferBalanceImprovingEntries !== false,
        balanceGovernorPreferLossOffset: balanceGovernor.preferBalanceImprovingLossOffset !== false,
        balanceGovernorRecomputeAfterClose: balanceGovernor.recomputeAfterClose !== false,
        balanceGovernorBlockWhenImbalanced: balanceGovernor.blockNewEntryWhenImbalanced !== false,
        balanceGovernorRebalanceProtectionEnabled: balanceGovernor.rebalanceProtectionEnabled === true,
        balanceGovernorRebalanceProtectionGraceMinutes: balanceGovernor.rebalanceProtectionGraceMinutes === 0
          ? 0
          : balanceGovernor.rebalanceProtectionGraceMinutes || 5,
        balanceGovernorRebalanceProtectionMaxLossPct: balanceGovernor.rebalanceProtectionMaxLossPct || 0.35,
        balanceGovernorRebalanceProtectionMaxClosesPerRun: balanceGovernor.rebalanceProtectionMaxClosesPerRun === 0
          ? 0
          : balanceGovernor.rebalanceProtectionMaxClosesPerRun || 1,
        balanceGovernorSequentialDamageTrimEnabled: balanceGovernor.sequentialDamageTrimEnabled === true,
        balanceGovernorSequentialDamageTrimClosePercent: balanceGovernor.sequentialDamageTrimClosePercent || 25,
        balanceGovernorPairScopedLossOffsetEnabled: balanceGovernor.pairScopedLossOffsetEnabled === true,
        balanceGovernorPairCloseCompanionEnabled: balanceGovernor.pairCloseCompanionEnabled === true,
        balanceGovernorPairCloseCompanionMode: balanceGovernor.pairCloseCompanionMode || 'PARTIAL_REBALANCE',
        balanceGovernorTransmissionMode: balanceGovernor.transmissionMode || 'SEQUENTIAL',
        balanceGovernorGradualTransmissionTriggerPnlPercent: balanceGovernor.gradualTransmissionTriggerPnlPercent === 0
          ? 0
          : balanceGovernor.gradualTransmissionTriggerPnlPercent || 0.2,
        balanceGovernorTransmissionFallbackEnabled: balanceGovernor.transmissionFallbackEnabled !== false,
        balanceGovernorTransmissionFallbackWaitMinutes: balanceGovernor.transmissionFallbackWaitMinutes || 30,
        balanceGovernorInitialTransmissionLevel: balanceGovernor.initialTransmissionLevel || 4,
        balanceGovernorStartTransmissionFromActiveLevels: balanceGovernor.startTransmissionFromActiveLevels === true,
        balanceGovernorStableDirectionRunsRequired: balanceGovernor.stableDirectionRunsRequired || 2,
        balanceGovernorCounterSideLevelStepDown: balanceGovernor.counterSideLevelStepDown === 0
          ? 0
          : balanceGovernor.counterSideLevelStepDown || 0.5,
        balanceGovernorMarketTableConfirmationStep: balanceGovernor.marketTableConfirmationStep === 0
          ? 0
          : balanceGovernor.marketTableConfirmationStep || 0.5,
        balanceGovernorLowScoreUncertainSwapEnabled: balanceGovernor.lowScoreUncertainSwapEnabled === true,
        balanceGovernorLowScoreUncertainSwapMaxScore: balanceGovernor.lowScoreUncertainSwapMaxScore === 0
          ? 0
          : balanceGovernor.lowScoreUncertainSwapMaxScore || 40,
        balanceGovernorLowScoreUncertainSwapMarketMode: balanceGovernor.lowScoreUncertainSwapMarketMode || 'RANGE_MIXED',
        balanceGovernorCruiseControlEnabled: balanceGovernor.cruiseControlEnabled === true,
        balanceGovernorReversalGuardEnabled: balanceGovernor.reversalGuardEnabled !== false,
        balanceGovernorSteeringModeMfe: balanceGovernor.transmissionSteeringMode === 'MFE_MOMENTUM',
        balanceGovernorMfeMomentumQualityMin: balanceGovernor.mfeMomentumQualityMin === 0 ? 0 : balanceGovernor.mfeMomentumQualityMin || 0.3,
        balanceGovernorTransferMode: balanceGovernor.transferMode || 'REALTIME',
        balanceGovernorTransferAction: balanceGovernor.transferAction || 'ADD_MARGIN_ONLY',
        balanceGovernorAutoManageTransmissionLevelsEnabled: balanceGovernor.autoManageTransmissionLevelsEnabled === true,
        balanceGovernorAutoManageTransmissionTriggerMode: balanceGovernor.autoManageTransmissionTriggerMode || 'PNL_PERCENT',
        balanceGovernorAutoManageTransmissionRealizedProfitTriggerPct: balanceGovernor.autoManageTransmissionRealizedProfitTriggerPct || 0.5,
        balanceGovernorAutoManageTransmissionClosedTradesTriggerCount: Math.max(1, Math.min(1000000, Math.floor(Number(balanceGovernor.autoManageTransmissionClosedTradesTriggerCount || 100)))),
        balanceGovernorAutoManageTransmissionLevelIncreasePercents: this.normalizedFourLevels(
          balanceGovernor.autoManageTransmissionLevelIncreasePercents,
          [10, 10, 10, 10],
          false,
        ),
        balanceGovernorAutoManageTransmissionLastAppliedStep: Math.max(0, Math.min(4, Math.floor(Number(balanceGovernor.autoManageTransmissionLastAppliedStep || 0)))),
        balanceGovernorAutoManageTransmissionBaseLeverageLevels: balanceGovernor.autoManageTransmissionBaseLeverageLevels || null,
        balanceGovernorAutoManageTransmissionBaseMarginLevelPercents: balanceGovernor.autoManageTransmissionBaseMarginLevelPercents || null,
        balanceGovernorAutoResetBalancesEnabled: balanceGovernor.autoResetBalancesEnabled === true,
        balanceGovernorAutoResetIntervalEnabled: balanceGovernor.autoResetIntervalEnabled === true,
        balanceGovernorAutoResetIntervalMinutes: balanceGovernor.autoResetIntervalMinutes || 60,
        balanceGovernorAutoResetUnrealizedProfitEnabled: balanceGovernor.autoResetUnrealizedProfitEnabled === true,
        balanceGovernorAutoResetUnrealizedProfitPct: balanceGovernor.autoResetUnrealizedProfitPct === 0
          ? 0
          : balanceGovernor.autoResetUnrealizedProfitPct || 0.5,
        balanceGovernorAutoResetCloseAgedPairEnabled: balanceGovernor.autoResetCloseAgedPairEnabled === true,
        balanceGovernorAutoResetCloseAgedPairMinutes: balanceGovernor.autoResetCloseAgedPairMinutes || 120,
        balanceGovernorAutoResetUnrealizedVsRealizedEnabled: balanceGovernor.autoResetUnrealizedVsRealizedEnabled === true,
        balanceGovernorAutoResetUnrealizedVsRealizedPct: balanceGovernor.autoResetUnrealizedVsRealizedPct === 0
          ? 0
          : balanceGovernor.autoResetUnrealizedVsRealizedPct || 50,
        balanceGovernorAutoResetFakeProfitProtectionEnabled: balanceGovernor.autoResetFakeProfitProtectionEnabled !== false,
        balanceGovernorAutoResetLastAt: balanceGovernor.autoResetLastAt || null,
        balanceGovernorPairWinnerTrailingEnabled: balanceGovernor.pairWinnerTrailingEnabled === true,
        balanceGovernorPairWinnerTrailingTriggerPnlPct: balanceGovernor.pairWinnerTrailingTriggerPnlPct === 0
          ? 0
          : balanceGovernor.pairWinnerTrailingTriggerPnlPct || 1.5,
        balanceGovernorPairWinnerTrailingOffsetPnlPct: balanceGovernor.pairWinnerTrailingOffsetPnlPct || 0.6,
        balanceGovernorHedgePairLifecycleEnabled: balanceGovernor.hedgePairLifecycleEnabled === true,
        balanceGovernorHedgePairWinnerMinPnlPercent: balanceGovernor.hedgePairWinnerMinPnlPercent === 0
          ? 0
          : balanceGovernor.hedgePairWinnerMinPnlPercent || 0.18,
        balanceGovernorHedgePairWinnerMinNetUsdt: balanceGovernor.hedgePairWinnerMinNetUsdt === 0
          ? 0
          : balanceGovernor.hedgePairWinnerMinNetUsdt || 0,
        balanceGovernorHedgePairWinnerConfirmRuns: balanceGovernor.hedgePairWinnerConfirmRuns || 2,
        balanceGovernorHedgePairWinnerMfeMaeConfirmEnabled: balanceGovernor.hedgePairWinnerMfeMaeConfirmEnabled !== false,
        balanceGovernorHedgePairWinnerMfeMaeMinRatio: balanceGovernor.hedgePairWinnerMfeMaeMinRatio === 0
          ? 0
          : balanceGovernor.hedgePairWinnerMfeMaeMinRatio || 1.2,
        balanceGovernorHedgePairLoserFirstTrimPercent: balanceGovernor.hedgePairLoserFirstTrimPercent || 25,
        balanceGovernorHedgePairLoserSecondTrimPercent: balanceGovernor.hedgePairLoserSecondTrimPercent || 25,
        balanceGovernorHedgePairMaxTrimCount: balanceGovernor.hedgePairMaxTrimCount || 2,
        balanceGovernorHedgePairMaxLoserTrimPerRun: balanceGovernor.hedgePairMaxLoserTrimPerRun || 1,
        balanceGovernorHedgePairLoserMinLossPercent: balanceGovernor.hedgePairLoserMinLossPercent === 0
          ? 0
          : balanceGovernor.hedgePairLoserMinLossPercent || 0.1,
        balanceGovernorHedgePairWinnerProfitUsablePercent: balanceGovernor.hedgePairWinnerProfitUsablePercent === 0
          ? 0
          : balanceGovernor.hedgePairWinnerProfitUsablePercent || 60,
        balanceGovernorHedgePairUseRealizedBuffer: balanceGovernor.hedgePairUseRealizedBuffer !== false,
        balanceGovernorHedgePairUseUnrealizedWinnerAssist: balanceGovernor.hedgePairUseUnrealizedWinnerAssist !== false,
        balanceGovernorHedgePairActivateWinnerTrailingOnTrim: balanceGovernor.hedgePairActivateWinnerTrailingOnTrim !== false,
        balanceGovernorHedgePairWinnerTrailingTriggerPnlPct: balanceGovernor.hedgePairWinnerTrailingTriggerPnlPct === 0
          ? 0
          : balanceGovernor.hedgePairWinnerTrailingTriggerPnlPct || 0.2,
        balanceGovernorHedgePairWinnerTrailingOffsetPnlPct: balanceGovernor.hedgePairWinnerTrailingOffsetPnlPct || 0.08,
        balanceGovernorHedgePairProtectWinnerFromGeneralCleanup: balanceGovernor.hedgePairProtectWinnerFromGeneralCleanup !== false,
        balanceGovernorHedgePairOnlySamePairCleanup: balanceGovernor.hedgePairOnlySamePairCleanup !== false,
        balanceGovernorHedgePairBlockGenericLossOffsetWhileManaged: balanceGovernor.hedgePairBlockGenericLossOffsetWhileManaged !== false,
        balanceGovernorLongLeverageLevels: this.normalizedFourLevels(
          this.safeObject(balanceGovernor.leverageLevels).LONG,
          [10, 15, 20, 30],
          true,
        ),
        balanceGovernorShortLeverageLevels: this.normalizedFourLevels(
          this.safeObject(balanceGovernor.leverageLevels).SHORT,
          [10, 15, 20, 30],
          true,
        ),
        balanceGovernorLongMarginLevelPercents: this.normalizedFourLevels(
          this.safeObject(balanceGovernor.marginLevelPercents).LONG,
          [25, 50, 75, 100],
          false,
        ),
        balanceGovernorShortMarginLevelPercents: this.normalizedFourLevels(
          this.safeObject(balanceGovernor.marginLevelPercents).SHORT,
          [25, 50, 75, 100],
          false,
        ),
        balanceGovernorSafeCloseEnabled: balanceGovernor.safeCloseEnabled === true,
        balanceGovernorSafeCloseMode: balanceGovernor.safeCloseMode || 'UNTARGETED',
        balanceGovernorSafeCloseRealizedProfitTargetUsdt: balanceGovernor.safeCloseRealizedProfitTargetUsdt || 0,
        balanceGovernorSafeCloseMaxProfitGivebackPercent: balanceGovernor.safeCloseMaxProfitGivebackPercent === 0
          ? 0
          : balanceGovernor.safeCloseMaxProfitGivebackPercent || 50,
        executionPolicy: rule.executionPolicy || 'REQUIRE_APPROVAL',
        allowOpenNewPosition: opportunityPolicy.allowOpenNewPosition === true,
        allowProtectExisting: opportunityPolicy.allowProtectExisting !== false,
        allowCloseAndOpenNew: opportunityPolicy.allowCloseAndOpenNew === true,
        indicatorExitSignalEnabled: opportunityPolicy.indicatorExitSignalEnabled !== false,
        immediateBotAssignmentEnabled: opportunityPolicy.immediateBotAssignmentEnabled === true,
        minOpportunityScoreDelta: opportunityPolicy.minOpportunityScoreDelta || 0.15,
        maxLateEntryRisk: opportunityPolicy.maxLateEntryRisk || 'MEDIUM',
        harvestProfitablePositions: opportunityPolicy.harvestProfitablePositions === true,
        harvestScopeBot: opportunityPolicy.harvestScope === 'BOT',
        harvestBudgetPct: opportunityPolicy.harvestBudgetPct || 10,
        profitCloseMinPnlPct: opportunityPolicy.profitCloseMinPnlPct || 0,
        lossOffsetCloseEnabled: opportunityPolicy.lossOffsetCloseEnabled === true,
        requireProfitHarvestForLossOffset: opportunityPolicy.requireProfitHarvestForLossOffset === true,
        lossOffsetProfitMultipleEnabled: opportunityPolicy.lossOffsetProfitMultipleEnabled === true,
        lossOffsetProfitMultiple: opportunityPolicy.lossOffsetProfitMultiple || 1,
        lossOffsetMinLossPct: opportunityPolicy.lossOffsetMinLossPct || 0,
        lossOffsetLargestFirst: opportunityPolicy.lossOffsetSelectionMode !== 'SMALLEST_LOSS',
        partialLossCloseEnabled: opportunityPolicy.partialLossCloseEnabled === true,
        partialLossCloseAllEligible: opportunityPolicy.partialLossCloseAllEligible === true,
        partialLossCloseThresholdEnabled: opportunityPolicy.partialLossCloseThresholdEnabled === true,
        partialLossCloseThresholdPnlPct: opportunityPolicy.partialLossCloseThresholdPnlPct || 0,
        partialLossClosePercent: opportunityPolicy.partialLossClosePercent || 25,
        maxPartialLossOffsetsPerRun: opportunityPolicy.maxPartialLossOffsetsPerRun === 0
          ? 0
          : opportunityPolicy.maxPartialLossOffsetsPerRun || 1,
        timedLossOffsetEnabled: opportunityPolicy.timedLossOffsetEnabled === true,
        timedLossOffsetIntervalMinutes: opportunityPolicy.timedLossOffsetIntervalMinutes || 60,
        timedLossOffsetMinLossPct: opportunityPolicy.timedLossOffsetMinLossPct || 0,
        timedLossOffsetProfitSharePct: opportunityPolicy.timedLossOffsetProfitSharePct === 0
          ? 0
          : opportunityPolicy.timedLossOffsetProfitSharePct || 100,
        rapidLossCloseEnabled: opportunityPolicy.rapidLossCloseEnabled === true,
        rapidLossCloseWindowMinutes: opportunityPolicy.rapidLossCloseWindowMinutes || 10,
        rapidLossCloseMinLossPct: opportunityPolicy.rapidLossCloseMinLossPct || 0.75,
        maxRapidLossClosesPerRun: opportunityPolicy.maxRapidLossClosesPerRun === 0
          ? 0
          : opportunityPolicy.maxRapidLossClosesPerRun || 1,
        profitLossCleanupEnabled: opportunityPolicy.profitLossCleanupEnabled === true,
        profitLossCleanupMode: opportunityPolicy.profitLossCleanupMode || 'SINGLE_POSITION',
        profitLossCleanupMinimumPnlPercent: opportunityPolicy.profitLossCleanupMinimumPnlPercent === 0
          ? 0
          : opportunityPolicy.profitLossCleanupMinimumPnlPercent || 0.8,
        profitLossCleanupPercent: opportunityPolicy.profitLossCleanupPercent === 0
          ? 0
          : opportunityPolicy.profitLossCleanupPercent || 75,
        profitLossCleanupPartialLossEnabled: opportunityPolicy.profitLossCleanupPartialLossEnabled === true,
        distributeRealizedProfitToPositionsEnabled: opportunityPolicy.distributeRealizedProfitToPositionsEnabled === true,
        realizedProfitDistributionTiming: opportunityPolicy.realizedProfitDistributionTiming || 'ACTIVE_AND_CLOSED_BUDGET',
        realizedProfitDistributionSharePct: opportunityPolicy.realizedProfitDistributionSharePct === 0
          ? 0
          : opportunityPolicy.realizedProfitDistributionSharePct || 30,
        realizedProfitDistributionReservePct: opportunityPolicy.realizedProfitDistributionReservePct === 0
          ? 0
          : opportunityPolicy.realizedProfitDistributionReservePct || 50,
        realizedProfitDistributionSafetyPct: opportunityPolicy.realizedProfitDistributionSafetyPct === 0
          ? 0
          : opportunityPolicy.realizedProfitDistributionSafetyPct || 20,
        realizedProfitDistributionMaxSlRiskBufferPct: opportunityPolicy.realizedProfitDistributionMaxSlRiskBufferPct === 0
          ? 0
          : opportunityPolicy.realizedProfitDistributionMaxSlRiskBufferPct || 50,
        realizedProfitDistributionMaxExtraPerPositionUsdt: opportunityPolicy.realizedProfitDistributionMaxExtraPerPositionUsdt === 0
          ? 0
          : opportunityPolicy.realizedProfitDistributionMaxExtraPerPositionUsdt || 25,
        realizedProfitDistributionMaxBudgetMultiplier: opportunityPolicy.realizedProfitDistributionMaxBudgetMultiplier || 2,
        realizedProfitDistributionMinProfitUsdt: opportunityPolicy.realizedProfitDistributionMinProfitUsdt || 0,
        scheduleEnabled: schedule.enabled === true,
        intervalMinutes: schedule.intervalMinutes || 5,
        cooldownMinutes: schedule.cooldownMinutes || 0,
        timeoutSeconds: schedule.timeoutSeconds || 60,
        runAfterRescan: schedule.runAfterRescan !== false,
      }
    },
    buildRuleBody() {
      const targetId = Number(this.form.targetId || 0) || undefined
      const { scope } = this.form
      const coins = this.parseList(this.form.coinsText)
      const timeframes = this.parseList(this.form.timeframesText).map(item => item.toLowerCase())
      const safeTimeframes = timeframes.length ? timeframes : ['1h']
      const useEdgeLibrary = this.form.coinPoolTfMode === 'EDGE_LIBRARY'
      const topNEdges = Math.min(500, Math.max(1, Math.round(this.nullableNumber(this.form.topNEdges) || 20)))
      const marketScoreGateA = Math.max(0, Math.min(100, Number(this.form.marketScoreGateMin ?? 0)))
      const marketScoreGateB = Math.max(0, Math.min(100, Number(this.form.marketScoreGateMax ?? 100)))
      const marketScoreGateMin = Math.min(marketScoreGateA, marketScoreGateB)
      const marketScoreGateMax = Math.max(marketScoreGateA, marketScoreGateB)
      const sides = []
      if (this.form.sideLong) sides.push('LONG')
      if (this.form.sideShort) sides.push('SHORT')
      if (sides.length === 0) sides.push('LONG')

      return {
        name: this.form.name,
        enabled: Boolean(this.form.enabled),
        source: {
          engineKey: this.form.engineKey,
          market: this.form.market,
          timeframes: safeTimeframes,
          marketScoreGateMin,
          marketScoreGateMax,
          coinUniverse: useEdgeLibrary
            ? {
              source: 'EDGE_LIBRARY',
              coins: [],
              edgeKind: this.form.edgeKind || undefined,
              topNEdges,
              useEdgeTimeframes: Boolean(this.form.useEdgeTimeframes),
              targetId: scope === 'TARGET_SCOPED' ? targetId : undefined,
            }
            : {
              source: coins.length ? 'MANUAL' : 'TARGET_POOL',
              coins,
              targetId: scope === 'TARGET_SCOPED' ? targetId : undefined,
            },
        },
        filters: {
          sides,
          minScore: this.nullableNumber(this.form.minScore),
          minConfidence: this.nullableNumber(this.form.minConfidence),
          maxSignalAgeBars: this.nullableNumber(this.form.maxSignalAgeBars),
          maxSignalAgeMinutes: this.nullableNumber(this.form.maxSignalAgeMinutes),
          maxMaePct: this.nullableNumber(this.form.maxMaePct),
          minMfePct: this.nullableNumber(this.form.minMfePct),
          blockDuplicateSignal: Boolean(this.form.blockDuplicateSignal),
          blockSameSymbolOpenPosition: Boolean(this.form.blockSameSymbolOpenPosition),
        },
        assignment: {
          scope,
          targetId: scope === 'TARGET_SCOPED' ? targetId : null,
          executionMode: this.form.executionMode || 'TESTNET',
          apiKeyId: this.form.executionMode === 'LIVE' ? this.nullableNumber(this.form.apiKeyId) : null,
          acknowledgeLiveExecutionRisk: this.form.executionMode === 'LIVE'
            ? Boolean(this.form.acknowledgeLiveExecutionRisk)
            : false,
          botSelectionMode: this.form.botSelectionMode,
          maxBotsToCreate: this.nullableNumber(this.form.maxBotsToCreate),
          maxSameSymbolPositions: this.nullableNumber(this.form.maxSameSymbolPositions),
          preferExistingSymbolBot: true,
          allowTargetlessExecution: scope === 'ACCOUNT_SCOPED',
          pairBalancedEntriesEnabled: Boolean(this.form.pairBalancedEntriesEnabled),
          pairHedgeOnlyEnabled: Boolean(this.form.pairBalancedEntriesEnabled && this.form.pairHedgeOnlyEnabled),
          pairImmediateHedgeRefillEnabled: Boolean(
            this.form.pairBalancedEntriesEnabled
            && this.form.pairHedgeOnlyEnabled
            && this.form.pairImmediateHedgeRefillEnabled,
          ),
          pairSuitableCoinsEnabled: Boolean(this.form.pairBalancedEntriesEnabled && this.form.pairSuitableCoinsEnabled),
          pairMinScore: this.nullableNumber(this.form.pairMinScore),
          pairMinConfidence: this.nullableNumber(this.form.pairMinConfidence),
          pairMaxLateEntryRisk: this.form.pairMaxLateEntryRisk || 'MEDIUM',
          pairBlockExhaustedDecay: this.form.pairBlockExhaustedDecay !== false,
          pairUnlockWithProfitBasket: this.form.pairUnlockWithProfitBasket !== false,
          pairSuggestExtraSlotWhenLocked: this.form.pairSuggestExtraSlotWhenLocked !== false,
        },
        budget: {
          enabled: Boolean(this.form.budgetEnabled),
          profile: 'BALANCED',
          dailyMaxNewPositions: Number(this.form.dailyMaxNewPositions || 0),
          maxOpenPositions: Number(this.form.maxOpenPositions || 0),
          maxPerPositionMarginUsdt: Number(this.form.maxPerPositionMarginUsdt || 0),
          maxSameSymbolPositions: Number(this.form.maxSameSymbolPositions || 0),
          longShortBalanceEnabled: Boolean(this.form.longShortBalanceEnabled),
          maxDirectionalBiasPct: Number(this.form.maxDirectionalBiasPct || 70),
          minPositionsForLongShortBalance: 2,
        },
        riskLimits: {
          maxDailyEntries: Number(this.form.dailyMaxNewPositions || 0),
          maxOpenPositions: Number(this.form.maxOpenPositions || 0),
          maxSameSymbolOpenPositions: Number(this.form.maxSameSymbolPositions || 0),
        },
        runtimeConfig: {
          tpPerc: Number(this.form.tpPerc || 2.5),
          slPerc: Number(this.form.slPerc || 1),
          leverage: Number(this.form.leverage || 10),
          commissionPerSide: Number(this.form.commissionPerSide || 0.05),
          adaptiveTpSlSynchronizerEnabled: Boolean(this.form.adaptiveTpSlSynchronizerEnabled),
          adaptiveTpSlKeepProfitMarginEnabled: Boolean(this.form.adaptiveTpSlKeepProfitMarginEnabled),
          adaptiveTpSlMaeCutPercent: Number(this.form.adaptiveTpSlMaeCutPercent ?? 25),
          adaptiveTpSlMaeBufferPercent: Number(this.form.adaptiveTpSlMaeCutPercent ?? 25),
          adaptiveTpSlMfePercentile: Math.max(1, Math.min(99, Math.floor(Number(this.form.adaptiveTpSlMfePercentile || 65)))),
          adaptiveTpSlMaePercentile: Math.max(1, Math.min(99, Math.floor(Number(this.form.adaptiveTpSlMaePercentile || 75)))),
          adaptiveTpSlRollingWindowRuns: Math.max(1, Math.min(24, Math.floor(Number(this.form.adaptiveTpSlRollingWindowRuns || 6)))),
          adaptiveTpSlMaxTpPerc: Number(this.form.adaptiveTpSlMaxTpPerc ?? 10),
          adaptiveTpSlMaxSlPerc: Number(this.form.adaptiveTpSlMaxSlPerc ?? 5),
          adaptiveTpSlSymbolAdaptationEnabled: Boolean(this.form.adaptiveTpSlSymbolAdaptationEnabled),
          adaptiveTpSlSymbolWeightPercent: Number(this.form.adaptiveTpSlSymbolWeightPercent ?? 50),
          adaptiveTpSlAlignProfitLossCleanupEnabled: Boolean(this.form.adaptiveTpSlAlignProfitLossCleanupEnabled),
          adaptiveTpSlProfitLossCleanupBandPercent: Math.max(0, Math.min(100, Number(this.form.adaptiveTpSlProfitLossCleanupBandPercent ?? 60))),
          adaptiveTpSlSyncOpportunityControlsEnabled: Boolean(this.form.adaptiveTpSlSyncOpportunityControlsEnabled),
          adaptiveTpSlPreviousTpPerc: this.form.adaptiveTpSlPreviousTpPerc,
          adaptiveTpSlPreviousSlPerc: this.form.adaptiveTpSlPreviousSlPerc,
          adaptiveTpSlCurrentMfePct: this.form.adaptiveTpSlCurrentMfePct,
          adaptiveTpSlCurrentMaePct: this.form.adaptiveTpSlCurrentMaePct,
          adaptiveTpSlPreviousMfePct: this.form.adaptiveTpSlPreviousMfePct,
          adaptiveTpSlPreviousMaePct: this.form.adaptiveTpSlPreviousMaePct,
        },
        balanceGovernor: {
          enabled: Boolean(this.form.balanceGovernorEnabled),
          mode: this.form.balanceGovernorMode || 'BALANCED',
          maxSideGap: Number(this.form.balanceGovernorMaxSideGap ?? 1),
          oddSlotPolicy: this.form.balanceGovernorOddSlotPolicy || 'TRY_PROFIT_POCKET_UNLOCK',
          preferBalanceImprovingEntries: Boolean(this.form.balanceGovernorPreferEntries),
          preferBalanceImprovingLossOffset: Boolean(this.form.balanceGovernorPreferLossOffset),
          recomputeAfterClose: Boolean(this.form.balanceGovernorRecomputeAfterClose),
          blockNewEntryWhenImbalanced: Boolean(this.form.balanceGovernorBlockWhenImbalanced),
          rebalanceProtectionEnabled: Boolean(this.form.balanceGovernorRebalanceProtectionEnabled),
          rebalanceProtectionGraceMinutes: Number(this.form.balanceGovernorRebalanceProtectionGraceMinutes ?? 5),
          rebalanceProtectionMaxLossPct: Number(this.form.balanceGovernorRebalanceProtectionMaxLossPct || 0.35),
          rebalanceProtectionMaxClosesPerRun: Number(this.form.balanceGovernorRebalanceProtectionMaxClosesPerRun ?? 1),
          sequentialDamageTrimEnabled: Boolean(this.form.balanceGovernorSequentialDamageTrimEnabled),
          sequentialDamageTrimClosePercent: Number(this.form.balanceGovernorSequentialDamageTrimClosePercent || 25),
          pairScopedLossOffsetEnabled: Boolean(this.form.balanceGovernorPairScopedLossOffsetEnabled),
          pairCloseCompanionEnabled: Boolean(this.form.balanceGovernorPairCloseCompanionEnabled),
          pairCloseCompanionMode: this.form.balanceGovernorPairCloseCompanionMode || 'PARTIAL_REBALANCE',
          transmissionMode: this.form.balanceGovernorTransmissionMode || 'SEQUENTIAL',
          gradualTransmissionTriggerPnlPercent: Number(this.form.balanceGovernorGradualTransmissionTriggerPnlPercent ?? 0.2),
          transmissionFallbackEnabled: Boolean(this.form.balanceGovernorTransmissionFallbackEnabled),
          transmissionFallbackWaitMinutes: Math.max(1, Math.min(10080, Math.floor(Number(this.form.balanceGovernorTransmissionFallbackWaitMinutes || 30)))),
          initialTransmissionLevel: Number(this.form.balanceGovernorInitialTransmissionLevel || 4),
          startTransmissionFromActiveLevels: Boolean(this.form.balanceGovernorStartTransmissionFromActiveLevels),
          stableDirectionRunsRequired: Number(this.form.balanceGovernorStableDirectionRunsRequired || 2),
          counterSideLevelStepDown: Number(this.form.balanceGovernorCounterSideLevelStepDown ?? 0.5),
          marketTableConfirmationStep: Number(this.form.balanceGovernorMarketTableConfirmationStep ?? 0.5),
          lowScoreUncertainSwapEnabled: Boolean(this.form.balanceGovernorLowScoreUncertainSwapEnabled),
          lowScoreUncertainSwapMaxScore: Number(this.form.balanceGovernorLowScoreUncertainSwapMaxScore ?? 40),
          lowScoreUncertainSwapMarketMode: this.form.balanceGovernorLowScoreUncertainSwapMarketMode || 'RANGE_MIXED',
          cruiseControlEnabled: Boolean(this.form.balanceGovernorCruiseControlEnabled),
          reversalGuardEnabled: this.form.balanceGovernorReversalGuardEnabled !== false,
          transmissionSteeringMode: this.form.balanceGovernorSteeringModeMfe ? 'MFE_MOMENTUM' : 'ABSOLUTE_PNL',
          mfeMomentumQualityMin: Number(this.form.balanceGovernorMfeMomentumQualityMin ?? 0.3),
          transferMode: this.form.balanceGovernorTransferMode || 'REALTIME',
          transferAction: this.form.balanceGovernorTransferAction || 'ADD_MARGIN_ONLY',
          autoManageTransmissionLevelsEnabled: Boolean(this.form.balanceGovernorAutoManageTransmissionLevelsEnabled),
          autoManageTransmissionTriggerMode: this.form.balanceGovernorAutoManageTransmissionTriggerMode || 'PNL_PERCENT',
          autoManageTransmissionRealizedProfitTriggerPct: Math.max(0.01, Math.min(100, Number(this.form.balanceGovernorAutoManageTransmissionRealizedProfitTriggerPct || 0.5))),
          autoManageTransmissionClosedTradesTriggerCount: Math.max(1, Math.min(1000000, Math.floor(Number(this.form.balanceGovernorAutoManageTransmissionClosedTradesTriggerCount || 100)))),
          autoManageTransmissionLevelIncreasePercents: this.normalizedFourLevels(
            this.form.balanceGovernorAutoManageTransmissionLevelIncreasePercents,
            [10, 10, 10, 10],
            false,
          ).map(value => Math.max(0, Math.min(100, Number(value || 0)))),
          autoManageTransmissionLastAppliedStep: Math.max(0, Math.min(4, Math.floor(Number(this.form.balanceGovernorAutoManageTransmissionLastAppliedStep || 0)))),
          autoManageTransmissionBaseLeverageLevels: this.form.balanceGovernorAutoManageTransmissionBaseLeverageLevels
            ? {
              LONG: this.normalizedTransmissionLeverageLevels(this.safeObject(this.form.balanceGovernorAutoManageTransmissionBaseLeverageLevels).LONG, [10, 15, 20, 30]),
              SHORT: this.normalizedTransmissionLeverageLevels(this.safeObject(this.form.balanceGovernorAutoManageTransmissionBaseLeverageLevels).SHORT, [10, 15, 20, 30]),
            }
            : undefined,
          autoManageTransmissionBaseMarginLevelPercents: this.form.balanceGovernorAutoManageTransmissionBaseMarginLevelPercents
            ? {
              LONG: this.normalizedFourLevels(this.safeObject(this.form.balanceGovernorAutoManageTransmissionBaseMarginLevelPercents).LONG, [25, 50, 75, 100], false)
                .map(value => Math.max(0, Math.min(100, Number(value || 0)))),
              SHORT: this.normalizedFourLevels(this.safeObject(this.form.balanceGovernorAutoManageTransmissionBaseMarginLevelPercents).SHORT, [25, 50, 75, 100], false)
                .map(value => Math.max(0, Math.min(100, Number(value || 0)))),
            }
            : undefined,
          autoResetBalancesEnabled: Boolean(this.form.balanceGovernorAutoResetBalancesEnabled),
          autoResetIntervalEnabled: Boolean(this.form.balanceGovernorAutoResetIntervalEnabled),
          autoResetIntervalMinutes: Math.max(1, Math.min(10080, Math.floor(Number(this.form.balanceGovernorAutoResetIntervalMinutes || 60)))),
          autoResetUnrealizedProfitEnabled: Boolean(this.form.balanceGovernorAutoResetUnrealizedProfitEnabled),
          autoResetUnrealizedProfitPct: Math.max(0, Math.min(100, Number(this.form.balanceGovernorAutoResetUnrealizedProfitPct ?? 0.5))),
          autoResetCloseAgedPairEnabled: Boolean(this.form.balanceGovernorAutoResetCloseAgedPairEnabled),
          autoResetCloseAgedPairMinutes: Math.max(1, Math.min(10080, Math.floor(Number(this.form.balanceGovernorAutoResetCloseAgedPairMinutes || 120)))),
          autoResetUnrealizedVsRealizedEnabled: Boolean(this.form.balanceGovernorAutoResetUnrealizedVsRealizedEnabled),
          autoResetUnrealizedVsRealizedPct: Math.max(0, Math.min(1000, Number(this.form.balanceGovernorAutoResetUnrealizedVsRealizedPct ?? 50))),
          autoResetFakeProfitProtectionEnabled: this.form.balanceGovernorAutoResetFakeProfitProtectionEnabled !== false,
          autoResetLastAt: this.form.balanceGovernorAutoResetLastAt || undefined,
          pairWinnerTrailingEnabled: Boolean(this.form.balanceGovernorPairWinnerTrailingEnabled),
          pairWinnerTrailingTriggerPnlPct: Math.max(0, Math.min(100, Number(this.form.balanceGovernorPairWinnerTrailingTriggerPnlPct ?? 1.5))),
          pairWinnerTrailingOffsetPnlPct: Math.max(0.01, Math.min(100, Number(this.form.balanceGovernorPairWinnerTrailingOffsetPnlPct || 0.6))),
          hedgePairLifecycleEnabled: Boolean(this.form.balanceGovernorHedgePairLifecycleEnabled),
          hedgePairWinnerMinPnlPercent: Math.max(0, Math.min(100, Number(this.form.balanceGovernorHedgePairWinnerMinPnlPercent ?? 0.18))),
          hedgePairWinnerMinNetUsdt: Math.max(0, Number(this.form.balanceGovernorHedgePairWinnerMinNetUsdt || 0)),
          hedgePairWinnerConfirmRuns: Math.max(1, Math.min(120, Math.floor(Number(this.form.balanceGovernorHedgePairWinnerConfirmRuns || 2)))),
          hedgePairWinnerMfeMaeConfirmEnabled: this.form.balanceGovernorHedgePairWinnerMfeMaeConfirmEnabled !== false,
          hedgePairWinnerMfeMaeMinRatio: Math.max(0, Math.min(100, Number(this.form.balanceGovernorHedgePairWinnerMfeMaeMinRatio ?? 1.2))),
          hedgePairLoserFirstTrimPercent: Math.max(1, Math.min(95, Number(this.form.balanceGovernorHedgePairLoserFirstTrimPercent || 25))),
          hedgePairLoserSecondTrimPercent: Math.max(1, Math.min(95, Number(this.form.balanceGovernorHedgePairLoserSecondTrimPercent || 25))),
          hedgePairMaxTrimCount: Math.max(1, Math.min(10, Math.floor(Number(this.form.balanceGovernorHedgePairMaxTrimCount || 2)))),
          hedgePairMaxLoserTrimPerRun: Math.max(1, Math.min(10, Math.floor(Number(this.form.balanceGovernorHedgePairMaxLoserTrimPerRun || 1)))),
          hedgePairLoserMinLossPercent: Math.max(0, Math.min(100, Number(this.form.balanceGovernorHedgePairLoserMinLossPercent ?? 0.1))),
          hedgePairWinnerProfitUsablePercent: Math.max(0, Math.min(100, Number(this.form.balanceGovernorHedgePairWinnerProfitUsablePercent ?? 60))),
          hedgePairUseRealizedBuffer: this.form.balanceGovernorHedgePairUseRealizedBuffer !== false,
          hedgePairUseUnrealizedWinnerAssist: this.form.balanceGovernorHedgePairUseUnrealizedWinnerAssist !== false,
          hedgePairActivateWinnerTrailingOnTrim: this.form.balanceGovernorHedgePairActivateWinnerTrailingOnTrim !== false,
          hedgePairWinnerTrailingTriggerPnlPct: Math.max(0, Math.min(100, Number(this.form.balanceGovernorHedgePairWinnerTrailingTriggerPnlPct ?? 0.2))),
          hedgePairWinnerTrailingOffsetPnlPct: Math.max(0.01, Math.min(100, Number(this.form.balanceGovernorHedgePairWinnerTrailingOffsetPnlPct || 0.08))),
          hedgePairProtectWinnerFromGeneralCleanup: this.form.balanceGovernorHedgePairProtectWinnerFromGeneralCleanup !== false,
          hedgePairOnlySamePairCleanup: this.form.balanceGovernorHedgePairOnlySamePairCleanup !== false,
          hedgePairBlockGenericLossOffsetWhileManaged: this.form.balanceGovernorHedgePairBlockGenericLossOffsetWhileManaged !== false,
          leverageLevels: {
            LONG: this.normalizedTransmissionLeverageLevels(this.form.balanceGovernorLongLeverageLevels, [10, 15, 20, 30]),
            SHORT: this.normalizedTransmissionLeverageLevels(this.form.balanceGovernorShortLeverageLevels, [10, 15, 20, 30]),
          },
          marginLevelPercents: {
            LONG: this.normalizedFourLevels(this.form.balanceGovernorLongMarginLevelPercents, [25, 50, 75, 100], false)
              .map(value => Math.max(0, Math.min(100, Number(value || 0)))),
            SHORT: this.normalizedFourLevels(this.form.balanceGovernorShortMarginLevelPercents, [25, 50, 75, 100], false)
              .map(value => Math.max(0, Math.min(100, Number(value || 0)))),
          },
          safeCloseEnabled: Boolean(this.form.balanceGovernorSafeCloseEnabled),
          safeCloseMode: this.form.balanceGovernorSafeCloseMode || 'UNTARGETED',
          safeCloseRealizedProfitTargetUsdt: Number(this.form.balanceGovernorSafeCloseRealizedProfitTargetUsdt || 0),
          safeCloseMaxProfitGivebackPercent: Number(this.form.balanceGovernorSafeCloseMaxProfitGivebackPercent ?? 50),
        },
        opportunityPolicy: {
          enabled: true,
          indicatorExitSignalEnabled: Boolean(this.form.indicatorExitSignalEnabled),
          immediateBotAssignmentEnabled: Boolean(this.form.immediateBotAssignmentEnabled),
          allowOpenNewPosition: Boolean(this.form.allowOpenNewPosition),
          allowProtectExisting: Boolean(this.form.allowProtectExisting),
          allowPartialCloseExisting: false,
          allowCloseExisting: false,
          allowCloseAndOpenNew: Boolean(this.form.allowCloseAndOpenNew),
          requireBetterExpectedValue: true,
          minOpportunityScoreDelta: this.nullableNumber(this.form.minOpportunityScoreDelta),
          maxLateEntryRisk: this.form.maxLateEntryRisk,
          realizedProfitBufferMode: 'PREFER',
          harvestProfitablePositions: Boolean(this.form.harvestProfitablePositions),
          harvestScope: this.form.harvestScopeBot ? 'BOT' : 'BASKET',
          harvestBudgetPct: Number(this.form.harvestBudgetPct || 10),
          profitCloseMinPnlPct: Number(this.form.profitCloseMinPnlPct || 0),
          lossOffsetCloseEnabled: Boolean(this.form.lossOffsetCloseEnabled),
          requireProfitHarvestForLossOffset: Boolean(this.form.requireProfitHarvestForLossOffset),
          lossOffsetProfitMultipleEnabled: Boolean(this.form.lossOffsetProfitMultipleEnabled),
          lossOffsetProfitMultiple: Number(this.form.lossOffsetProfitMultiple || 1),
          lossOffsetMinLossPct: Number(this.form.lossOffsetMinLossPct || 0),
          lossOffsetSelectionMode: this.form.lossOffsetLargestFirst ? 'LARGEST_LOSS' : 'SMALLEST_LOSS',
          partialLossCloseEnabled: Boolean(this.form.partialLossCloseEnabled),
          partialLossCloseAllEligible: Boolean(this.form.partialLossCloseAllEligible),
          partialLossCloseThresholdEnabled: Boolean(this.form.partialLossCloseThresholdEnabled),
          partialLossCloseThresholdPnlPct: Number(this.form.partialLossCloseThresholdPnlPct || 0),
          partialLossClosePercent: Number(this.form.partialLossClosePercent || 25),
          maxPartialLossOffsetsPerRun: Number(this.form.maxPartialLossOffsetsPerRun ?? 1),
          timedLossOffsetEnabled: Boolean(this.form.timedLossOffsetEnabled),
          timedLossOffsetIntervalMinutes: Number(this.form.timedLossOffsetIntervalMinutes || 60),
          timedLossOffsetMinLossPct: Number(this.form.timedLossOffsetMinLossPct || 0),
          timedLossOffsetProfitSharePct: Number(this.form.timedLossOffsetProfitSharePct ?? 100),
          rapidLossCloseEnabled: Boolean(this.form.rapidLossCloseEnabled),
          rapidLossCloseWindowMinutes: Number(this.form.rapidLossCloseWindowMinutes || 10),
          rapidLossCloseMinLossPct: Number(this.form.rapidLossCloseMinLossPct || 0.75),
          maxRapidLossClosesPerRun: Number(this.form.maxRapidLossClosesPerRun ?? 1),
          maxLossOffsetsPerRun: 1,
          profitLossCleanupEnabled: Boolean(this.form.profitLossCleanupEnabled),
          profitLossCleanupMode: this.form.profitLossCleanupMode || 'SINGLE_POSITION',
          profitLossCleanupMinimumPnlPercent: Number(this.form.profitLossCleanupMinimumPnlPercent ?? 0.8),
          profitLossCleanupPercent: Number(this.form.profitLossCleanupPercent ?? 75),
          profitLossCleanupPartialLossEnabled: Boolean(this.form.profitLossCleanupPartialLossEnabled),
          distributeRealizedProfitToPositionsEnabled: Boolean(this.form.distributeRealizedProfitToPositionsEnabled),
          realizedProfitDistributionTiming: this.form.realizedProfitDistributionTiming || 'ACTIVE_AND_CLOSED_BUDGET',
          realizedProfitDistributionSharePct: Number(this.form.realizedProfitDistributionSharePct ?? 30),
          realizedProfitDistributionReservePct: Number(this.form.realizedProfitDistributionReservePct ?? 50),
          realizedProfitDistributionSafetyPct: Number(this.form.realizedProfitDistributionSafetyPct ?? 20),
          realizedProfitDistributionMaxSlRiskBufferPct: Number(this.form.realizedProfitDistributionMaxSlRiskBufferPct ?? 50),
          realizedProfitDistributionMaxExtraPerPositionUsdt: Number(this.form.realizedProfitDistributionMaxExtraPerPositionUsdt ?? 25),
          realizedProfitDistributionMaxBudgetMultiplier: Number(this.form.realizedProfitDistributionMaxBudgetMultiplier ?? 2),
          realizedProfitDistributionMinProfitUsdt: Number(this.form.realizedProfitDistributionMinProfitUsdt ?? 0),
        },
        executionPolicy: this.form.executionPolicy,
        schedule: {
          enabled: Boolean(this.form.scheduleEnabled),
          intervalMinutes: Number(this.form.intervalMinutes || 5),
          runAfterRescan: Boolean(this.form.runAfterRescan),
          cooldownMinutes: Number(this.form.cooldownMinutes || 0),
          timeoutSeconds: Number(this.form.timeoutSeconds || 60),
        },
      }
    },
    parseList(value) {
      return String(value || '')
        .split(/[,\n]/)
        .map(item => item.trim())
        .filter(Boolean)
    },
    nullableNumber(value) {
      if (value === null || value === undefined || value === '') return undefined
      const number = Number(value)
      return Number.isFinite(number) ? number : undefined
    },
    normalizedFourLevels(value, fallback, integer = false) {
      const source = Array.isArray(value) ? value : []
      const rows = [0, 1, 2, 3].map(index => {
        const number = Number(source[index])
        const fallbackNumber = Number(fallback[index])
        const safe = Number.isFinite(number) ? number : fallbackNumber
        return integer ? Math.max(1, Math.round(safe)) : safe
      })
      return rows
    },
    normalizedTransmissionLeverageLevels(value, fallback) {
      const max = this.maxTransmissionLeverage
      return this.normalizedFourLevels(value, fallback, true)
        .map(item => Math.max(1, Math.min(max, Math.round(Number(item || 1)))))
    },
    policyVariant(policy) {
      const map = {
        REQUIRE_APPROVAL: 'light-warning',
        AUTO_ASSIGN_ONLY: 'light-info',
        AUTO_PROTECT_ONLY: 'light-primary',
        AUTO_EXECUTE_WITH_LIMITS: 'light-danger',
      }
      return map[policy] || 'light-secondary'
    },
    policyLabel(policy) {
      const map = {
        REQUIRE_APPROVAL: 'onay',
        AUTO_ASSIGN_ONLY: 'atama',
        AUTO_PROTECT_ONLY: 'koruma',
        AUTO_EXECUTE_WITH_LIMITS: 'otomatik',
      }
      return map[policy] || policy
    },
    decisionStatusVariant(status) {
      const map = {
        QUEUED: 'light-warning',
        ASSIGNED: 'light-info',
        EXECUTED: 'light-success',
        REJECTED: 'light-danger',
        FAILED: 'danger',
        SKIPPED: 'light-secondary',
      }
      return map[status] || 'light-secondary'
    },
    runStatusVariant(status) {
      const map = {
        QUEUED: 'light-warning',
        RUNNING: 'light-info',
        DONE: 'light-success',
        FAILED: 'light-danger',
        CANCELLED: 'light-secondary',
      }
      return map[status] || 'light-secondary'
    },
    safeObject(value) {
      return value && typeof value === 'object' ? value : {}
    },
    profitPocketOf(item) {
      return this.safeObject(this.safeObject(item && item.riskSnapshot).profitPocket)
    },
    closeApprovalMode(item) {
      const { mode } = this.profitPocketOf(item)
      return typeof mode === 'string' ? mode : 'TESTNET'
    },
    canExecuteCloseDecision(item) {
      const pocket = this.profitPocketOf(item)
      return Boolean(item
        && item.status === 'QUEUED'
        && (item.action === 'CLOSE_EXISTING' || item.action === 'PARTIAL_CLOSE_EXISTING')
        && item.botId
        && item.positionId
        && pocket.type)
    },
    closeApprovalPartialText(item) {
      const pocket = this.profitPocketOf(item)
      const partial = this.safeObject(pocket.partialClose)
      if (!partial.enabled) return ''
      const pct = Number(partial.closePercent || 0)
      const planned = Number(partial.plannedLossCoverUsdt || 0)
      return `%${pct.toFixed(0)} kapatılacak · planlanan zarar parçası ${planned.toFixed(2)} USDT`
    },
    profitPocketPnlText(item) {
      const pocket = this.profitPocketOf(item)
      const value = Number(pocket.pnlUsdt || 0)
      return `${value.toFixed(2)} USDT`
    },
    profitPocketTargetText(item) {
      const pocket = this.profitPocketOf(item)
      const target = Number(pocket.targetHarvestUsdt || 0)
      return target > 0 ? `${target.toFixed(2)} USDT` : '—'
    },
    profitPocketTypeText(item) {
      const { type } = this.profitPocketOf(item)
      if (type === 'LOSS_OFFSET') return 'Karla zararı kapat'
      if (type === 'PROFIT_HARVEST') return 'Kar cebi'
      if (type === 'PAIR_UNLOCK') return 'Kar sepeti kilit açtı'
      if (type === 'RAPID_LOSS_CUT') return 'Hızlı zarar kesici'
      if (type === 'PROFIT_LOSS_CLEANUP_PROFIT') return 'Profit Loss Cleanup kar'
      if (type === 'PROFIT_LOSS_CLEANUP_LOSS') return 'Profit Loss Cleanup zarar'
      if (type === 'BALANCE_DAMAGE_TRIM') return 'Denge hasar kırpma'
      if (type === 'HEDGE_PAIR_LIFECYCLE_LOSER_TRIM') return 'Hedge lifecycle loser kırpma'
      return '—'
    },
    profitPocketBadgeText(item) {
      const { type } = this.profitPocketOf(item)
      if (type === 'LOSS_OFFSET') return 'Zarar offset'
      if (type === 'PROFIT_HARVEST') return 'Kar cebi'
      if (type === 'PAIR_UNLOCK') return 'Kilit açtı'
      if (type === 'RAPID_LOSS_CUT') return 'Hızlı zarar'
      if (type === 'PROFIT_LOSS_CLEANUP_PROFIT') return 'Cleanup kar'
      if (type === 'PROFIT_LOSS_CLEANUP_LOSS') return 'Cleanup zarar'
      if (type === 'BALANCE_DAMAGE_TRIM') return 'Denge kırpma'
      if (type === 'HEDGE_PAIR_LIFECYCLE_LOSER_TRIM') return 'Hedge lifecycle'
      return ''
    },
    profitPocketVariant(item) {
      const { type } = this.profitPocketOf(item)
      if (type === 'LOSS_OFFSET') return 'light-danger'
      if (type === 'PROFIT_HARVEST') return 'light-success'
      if (type === 'PAIR_UNLOCK') return 'light-info'
      if (type === 'RAPID_LOSS_CUT') return 'danger'
      if (type === 'PROFIT_LOSS_CLEANUP_PROFIT') return 'light-success'
      if (type === 'PROFIT_LOSS_CLEANUP_LOSS') return 'light-warning'
      if (type === 'BALANCE_DAMAGE_TRIM') return 'light-danger'
      if (type === 'HEDGE_PAIR_LIFECYCLE_LOSER_TRIM') return 'light-info'
      return 'light-secondary'
    },
    profitPocketStrict(item) {
      const pocket = this.profitPocketOf(item)
      return pocket.requireProfitHarvestForLossOffset === true
    },
    profitPocketDetailText(item) {
      const pocket = this.profitPocketOf(item)
      if (!pocket.type) return ''
      const pnl = Number(pocket.pnlUsdt || 0).toFixed(2)
      const target = Number(pocket.targetHarvestUsdt || 0)
      const cover = Number(pocket.coveredByProfitUsdt || 0)
      if (pocket.type === 'PROFIT_HARVEST') {
        return target > 0 ? `kapanacak kar ${pnl} USDT · hedef ${target.toFixed(2)} USDT` : `kapanacak kar ${pnl} USDT`
      }
      if (pocket.type === 'LOSS_OFFSET') {
        return cover > 0 ? `kapanacak zarar ${pnl} USDT · kar cover ${cover.toFixed(2)} USDT` : `kapanacak zarar ${pnl} USDT`
      }
      if (pocket.type === 'PAIR_UNLOCK') {
        return cover > 0 ? `kilit açmak için kapanacak zarar ${pnl} USDT · kar cover ${cover.toFixed(2)} USDT` : `kilit açmak için kapanacak zarar ${pnl} USDT`
      }
      if (pocket.type === 'RAPID_LOSS_CUT') {
        const rapid = this.safeObject(pocket.rapidLossClose)
        return `hızlı zarar ${pnl} USDT · eşik %${Number(rapid.minLossPct || 0).toFixed(2)} / ${Number(rapid.windowMinutes || 0).toFixed(0)} dk`
      }
      if (pocket.type === 'PROFIT_LOSS_CLEANUP_PROFIT') {
        const cleanup = this.safeObject(pocket.profitLossCleanup)
        return `cleanup karı ${pnl} USDT · ayrılan %${Number(cleanup.cleanupPercent || 0).toFixed(0)}`
      }
      if (pocket.type === 'PROFIT_LOSS_CLEANUP_LOSS') {
        const cleanup = this.safeObject(pocket.profitLossCleanup)
        const planned = Number(cleanup.plannedLossCoverUsdt || 0)
        return planned > 0
          ? `cleanup zararı ${pnl} USDT · planlanan ${planned.toFixed(2)} USDT`
          : `cleanup zararı ${pnl} USDT`
      }
      if (pocket.type === 'BALANCE_DAMAGE_TRIM') {
        const partial = this.safeObject(pocket.partialClose)
        const trim = this.safeObject(pocket.balanceDamageTrim)
        if (trim.role === 'PROFIT_COVER') {
          const coverUsdt = Number(trim.plannedProfitCoverUsdt || 0)
          return `denge hasarı için kar cover ${pnl} USDT · plan ${coverUsdt.toFixed(2)} USDT`
        }
        return `denge hasarı ${pnl} USDT · %${Number(partial.closePercent || 0).toFixed(0)} kırpma`
      }
      if (pocket.type === 'HEDGE_PAIR_LIFECYCLE_LOSER_TRIM') {
        const partial = this.safeObject(pocket.partialClose)
        const lifecycle = this.safeObject(pocket.hedgePairLifecycle)
        const planned = Number(lifecycle.plannedLossCoverUsdt || partial.plannedLossCoverUsdt || 0)
        const usable = Number(lifecycle.unrealizedWinnerCoverUsdt || 0) + Number(lifecycle.realizedCoverUsdt || 0)
        return `hedge loser ${pnl} USDT · %${Number(partial.closePercent || 0).toFixed(0)} kırpma · cover ${usable.toFixed(2)} / plan ${planned.toFixed(2)} USDT`
      }
      return ''
    },
    pairAssignmentOf(item) {
      return this.safeObject(this.safeObject(item && item.riskSnapshot).pairAssignment)
    },
    pairBadges(item) {
      const pair = this.pairAssignmentOf(item)
      if (!pair.enabled) return []
      const badges = []
      if (pair.status === 'COUNTER_SELECTED') {
        badges.push({ text: 'Eşli atama', variant: 'light-primary' })
      } else if (pair.status === 'COUNTER_NOT_FOUND') {
        badges.push({ text: 'Karşı aday yok', variant: 'light-warning' })
      }
      const unlock = this.safeObject(this.safeObject(item && item.riskSnapshot).profitPocket)
      if (unlock.type === 'PAIR_UNLOCK') {
        badges.push({ text: 'Kar sepeti kilit açtı', variant: 'light-info' })
      }
      const suggestion = this.safeObject(pair.extraSlotSuggestion)
      if (suggestion.suggested === true) {
        badges.push({ text: '+1 slot önerisi', variant: 'light-warning' })
      }
      const compatibility = this.safeObject(pair.compatibilitySummary)
      if (compatibility.enabled === true) {
        badges.push({
          text: compatibility.fallbackUsed === true ? 'Pair fallback' : 'Uygun pair',
          variant: compatibility.fallbackUsed === true ? 'light-warning' : 'light-success',
        })
      }
      const reasons = Array.isArray(item && item.reasons) ? item.reasons : []
      if (reasons.includes('ODD_SLOT_LOCK')) {
        badges.push({ text: 'Tek slot kilidi', variant: 'light-secondary' })
      }
      return badges
    },
    pairDetailText(item) {
      const pair = this.pairAssignmentOf(item)
      if (!pair.enabled) return ''
      const parts = []
      if (pair.role) parts.push(pair.role === 'PRIMARY' ? 'ana aday' : 'karşı aday')
      if (pair.primaryCandidateId && pair.counterCandidateId) {
        parts.push(`pair ${this.shortId(pair.primaryCandidateId)} / ${this.shortId(pair.counterCandidateId)}`)
      }
      const compatibility = this.safeObject(pair.compatibilitySummary)
      if (compatibility.enabled === true) {
        const score = Number(compatibility.selectedScore)
        const scoreText = Number.isFinite(score) ? `uyum ${score.toFixed(2)}` : 'uyum ölçüldü'
        parts.push(compatibility.selectedLabel ? `${scoreText}: ${compatibility.selectedLabel}` : scoreText)
      }
      const suggestion = this.safeObject(pair.extraSlotSuggestion)
      if (suggestion.suggested === true) {
        parts.push(`maks açık pozisyon ${suggestion.currentMaxOpenPositions} → ${suggestion.suggestedMaxOpenPositions}`)
      }
      const unlock = this.safeObject(pair.profitBasketUnlockCandidate)
      if (unlock.available === false && Array.isArray(unlock.reasons) && unlock.reasons.length) {
        parts.push(this.reasonLabel(unlock.reasons[0]))
      }
      return parts.join(' · ')
    },
    balanceGovernorOf(item) {
      return this.safeObject(this.safeObject(item && item.riskSnapshot).balanceGovernor)
    },
    balanceBadges(item) {
      const balance = this.balanceGovernorOf(item)
      if (!balance.enabled) return []
      const entry = this.safeObject(balance.entry)
      const oddSlot = this.safeObject(balance.oddSlot)
      const badges = []
      if (entry.blockedByBalance === true) {
        badges.push({ text: 'Denge entry blok', variant: 'light-warning' })
      } else if (entry.selectedSideImpact === 'IMPROVES') {
        badges.push({ text: 'Denge iyileşir', variant: 'light-success' })
      } else if (entry.selectedSideImpact === 'WORSENS') {
        badges.push({ text: 'Denge bozulur', variant: 'light-warning' })
      } else if (entry.selectedSideImpact === 'NEUTRAL') {
        badges.push({ text: 'Denge nötr', variant: 'light-secondary' })
      }
      if (oddSlot.blockedByBalance === true) {
        if (oddSlot.action === 'WAIT') {
          badges.push({ text: 'Tek slot bekliyor', variant: 'light-secondary' })
        } else if (oddSlot.action === 'TRY_PROFIT_POCKET_UNLOCK') {
          badges.push({ text: 'Kilit için kar sepeti', variant: 'light-info' })
        } else if (oddSlot.action === 'SUGGEST_EXTRA_SLOT') {
          badges.push({ text: '+1 slot öner', variant: 'light-warning' })
        } else {
          badges.push({ text: 'Tek slot blok', variant: 'light-warning' })
        }
      }
      return badges
    },
    balanceDetailText(item) {
      const balance = this.balanceGovernorOf(item)
      if (!balance.enabled) return ''
      const entry = this.safeObject(balance.entry)
      const oddSlot = this.safeObject(balance.oddSlot)
      const before = this.safeObject(entry.beforeSnapshot)
      const after = this.safeObject(entry.afterProjection)
      const parts = []
      if (before.openLongCount !== undefined || before.openShortCount !== undefined) {
        parts.push(`önce LONG ${Number(before.openLongCount || 0).toFixed(0)} / SHORT ${Number(before.openShortCount || 0).toFixed(0)}`)
      }
      if (before.sideGap !== undefined && after.sideGap !== undefined) {
        parts.push(`gap ${Number(before.sideGap || 0).toFixed(0)} → ${Number(after.sideGap || 0).toFixed(0)}`)
      }
      if (Array.isArray(entry.plannedSides) && entry.plannedSides.length) {
        parts.push(`plan ${entry.plannedSides.join(' + ')}`)
      }
      if (entry.skipReason) parts.push(this.reasonLabel(entry.skipReason))
      if (oddSlot.skipReason) parts.push(this.reasonLabel(oddSlot.skipReason))
      if (Number(oddSlot.suggestedExtraSlots || 0) > 0) {
        parts.push(`önerilen ek slot ${Number(oddSlot.suggestedExtraSlots || 0).toFixed(0)}`)
      }
      return parts.join(' · ')
    },
    shortId(value) {
      const text = String(value || '')
      if (text.length <= 16) return text
      return `${text.slice(0, 12)}…`
    },
    openCloseApproval(item) {
      this.closeApproval.item = item
      this.closeApproval.busy = false
      this.closeApproval.liveConfirm = false
      this.closeApproval.acknowledgeLiveCloseRisk = false
      this.$bvModal.show('close-approval-modal')
    },
    resetCloseApproval() {
      this.closeApproval.item = null
      this.closeApproval.busy = false
      this.closeApproval.liveConfirm = false
      this.closeApproval.acknowledgeLiveCloseRisk = false
    },
    executeCloseApproval() {
      if (!this.selectedRule || !this.closeApproval.item) return Promise.resolve()
      this.closeApproval.busy = true
      return this.$store.dispatch('signalAutomation/executeCloseDecision', {
        ruleId: this.selectedRule.id,
        decisionId: this.closeApproval.item.id,
        body: {
          liveConfirm: Boolean(this.closeApproval.liveConfirm),
          acknowledgeLiveCloseRisk: Boolean(this.closeApproval.acknowledgeLiveCloseRisk),
        },
      })
        .then(() => this.refreshDetailTables())
        .then(() => {
          this.$bvModal.hide('close-approval-modal')
        })
        .finally(() => {
          this.closeApproval.busy = false
        })
    },
    actionLabel(action) {
      const map = {
        NO_ACTION: 'Aksiyon yok',
        PROTECT_EXISTING: 'Pozisyonu koru',
        PARTIAL_CLOSE_EXISTING: 'Kısmi kapat',
        CLOSE_EXISTING: 'Pozisyonu kapat',
        OPEN_NEW_POSITION: 'Yeni pozisyon aç',
        OPEN_NEW_AND_PROTECT_EXISTING: 'Aç ve mevcutu koru',
        CLOSE_EXISTING_AND_OPEN_NEW: 'Kapat ve yeni aç',
        WAIT_FOR_CONFIRMATION: 'Onay bekle',
      }
      return map[action] || this.reasonLabel(action)
    },
    executionBridgeText(item) {
      const risk = this.safeObject(item && item.riskSnapshot)
      const closeApproval = this.safeObject(risk.closeApproval)
      if (closeApproval.status === 'DONE') {
        if (closeApproval.protectiveResizeEmergencyClosed) return 'partial çalıştı, kalan güvenlik için kapandı'
        return `onayla kapatıldı: ${Number(closeApproval.realizedPnl || 0).toFixed(2)} USDT`
      }
      if (closeApproval.status === 'FAILED') return `onay close hata: ${closeApproval.message || 'bilinmiyor'}`
      if (closeApproval.reason === 'LIVE_CLOSE_CONFIRM_REQUIRED') return 'LIVE close onayı bekliyor'
      const closeExecutor = this.safeObject(risk.closeExecutor)
      if (closeExecutor.status === 'DONE') {
        if (closeExecutor.protectiveResizeEmergencyClosed) return 'partial çalıştı, kalan güvenlik için kapandı'
        return `kapatıldı: ${Number(closeExecutor.realizedPnl || 0).toFixed(2)} USDT`
      }
      if (closeExecutor.status === 'FAILED') return `close hata: ${closeExecutor.message || 'bilinmiyor'}`
      if (closeExecutor.reason === 'PARTIAL_CLOSE_EXECUTOR_PENDING') return 'partial close executor bekliyor'
      if (closeExecutor.reason === 'LIVE_CLOSE_EXECUTION_DISABLED') return 'eski kayıt: LIVE close kapalı'
      const profitPocket = this.safeObject(risk.profitPocket)
      if (profitPocket.partialClose && profitPocket.partialClose.enabled) {
        if (profitPocket.type === 'PROFIT_LOSS_CLEANUP_LOSS') {
          return `cleanup partial zarar: %${Number(profitPocket.partialClose.closePercent || 0).toFixed(0)}`
        }
        return `partial zarar: %${Number(profitPocket.partialClose.closePercent || 0).toFixed(0)}`
      }
      if (profitPocket.type === 'PROFIT_HARVEST') {
        return `kar cebi: ${Number(profitPocket.pnlUsdt || 0).toFixed(2)} USDT`
      }
      if (profitPocket.type === 'LOSS_OFFSET') {
        return `zarar karla kapanabilir: ${Number(profitPocket.pnlUsdt || 0).toFixed(2)} USDT`
      }
      if (profitPocket.type === 'PAIR_UNLOCK') {
        return `kilit açma close: ${Number(profitPocket.pnlUsdt || 0).toFixed(2)} USDT`
      }
      if (profitPocket.type === 'RAPID_LOSS_CUT') {
        return `hızlı zarar close: ${Number(profitPocket.pnlUsdt || 0).toFixed(2)} USDT`
      }
      if (profitPocket.type === 'PROFIT_LOSS_CLEANUP_PROFIT') {
        return `cleanup kar kapanışı: ${Number(profitPocket.pnlUsdt || 0).toFixed(2)} USDT`
      }
      if (profitPocket.type === 'PROFIT_LOSS_CLEANUP_LOSS') {
        const cleanup = this.safeObject(profitPocket.profitLossCleanup)
        const planned = Number(cleanup.plannedLossCoverUsdt || 0)
        return planned > 0
          ? `cleanup zarar kapanışı: ${planned.toFixed(2)} USDT`
          : `cleanup zarar kapanışı: ${Number(profitPocket.pnlUsdt || 0).toFixed(2)} USDT`
      }
      const bridge = this.safeObject(risk.executionBridge)
      if (bridge.reason === 'LIVE_EXECUTION_DISABLED') return 'LIVE güvenli kapalı'
      if (bridge.reason === 'MARGIN_REQUIRED_FOR_AUTOMATION_EXECUTION') return 'margin yok, otomatik açılmadı'
      if (bridge.reason === 'NO_EXECUTABLE_ASSIGNMENT') return 'uygun bot bulunamadı'
      if (bridge.status === 'DONE' || bridge.opened > 0) return `açıldı ${bridge.opened || 0}`
      if (bridge.failed > 0) return `hata ${bridge.failed}`
      if (bridge.skipped > 0) return `skip ${bridge.skipped}`
      if (item && item.status === 'QUEUED') return 'onay/kuyruk bekliyor'
      if (item && item.status === 'ASSIGNED') return 'bot atandı'
      if (item && item.status === 'EXECUTED') return 'execute edildi'
      return '—'
    },
    executionSummaryNote(execution) {
      if (execution.liveBlocked) return 'LIVE fail-closed'
      const opened = Number(execution.opened || 0)
      const failed = Number(execution.failed || 0)
      const skipped = Number(execution.skipped || 0)
      if (opened > 0) return `açıldı ${opened}`
      if (failed > 0) return `hata ${failed}`
      if (skipped > 0) return `skip ${skipped}`
      if (this.latestRun) return 'aksiyon yok'
      return 'run yok'
    },
    runSummaryText(item) {
      if (!item) return '—'
      if (item.error) return item.error
      const summary = item.summary && typeof item.summary === 'object' ? item.summary : {}
      if (summary.reason === 'DISCOVERY_BRIDGE_COMPLETED') return 'Sinyal taraması ve karar üretimi tamamlandı'
      if (summary.reason === 'SIGNAL_DISCOVERY_BRIDGE_PENDING') {
        return 'Sinyal keşif/execute köprüsü henüz bağlı değil'
      }
      if (summary.reason === 'DISCOVERY_BRIDGE_ERROR') return 'Sinyal tarama köprüsü hata aldı'
      if (summary.reason) return this.reasonLabel(summary.reason)
      if (summary.processorStatus === 'BRIDGE_PENDING') return 'Köprü bekliyor'
      return '—'
    },
    runBalanceText(item) {
      const summary = this.safeObject(item && item.summary)
      const balance = this.safeObject(summary.balanceGovernorSummary)
      const snapshot = this.safeObject(balance.snapshot)
      if (balance.enabled !== true || !Object.keys(snapshot).length) return ''
      const status = snapshot.balanced === false ? 'dengesiz' : 'dengeli'
      const odd = snapshot.oddSlotLocked === true ? ' · tek slot' : ''
      return `Denge: ${status} · L ${Number(snapshot.openLongCount || 0).toFixed(0)} / S ${Number(snapshot.openShortCount || 0).toFixed(0)} · gap ${Number(snapshot.sideGap || 0).toFixed(0)}${odd}`
    },
    toggleMarketDirectionCoin(symbol) {
      this.marketDirectionExpandedSymbol = this.marketDirectionExpandedSymbol === symbol ? null : symbol
    },
    marketDirectionLabel(direction) {
      const map = {
        LONG_MARKET: 'Long piyasa',
        SHORT_MARKET: 'Short piyasa',
        RANGE_MARKET: 'Range',
        MIXED_MARKET: 'Karışık',
        NO_SIGNAL: 'Sinyal yok',
      }
      return map[direction] || 'Bilinmiyor'
    },
    marketDirectionVariant(direction) {
      const map = {
        LONG_MARKET: 'light-success',
        SHORT_MARKET: 'light-danger',
        RANGE_MARKET: 'light-info',
        MIXED_MARKET: 'light-warning',
        NO_SIGNAL: 'light-secondary',
      }
      return map[direction] || 'light-secondary'
    },
    marketDirectionGaugeClass(item) {
      const direction = item && item.direction
      if (direction === 'LONG_MARKET') return 'is-long'
      if (direction === 'SHORT_MARKET') return 'is-short'
      if (direction === 'RANGE_MARKET') return 'is-range'
      if (direction === 'MIXED_MARKET') return 'is-mixed'
      return 'is-empty'
    },
    marketDirectionGaugeStyle(score) {
      const value = Math.max(2, Math.min(100, Number(score || 0)))
      return { width: `${value}%` }
    },
    reasonLabel(reason) {
      if (!reason) return '—'
      return strategyReasonLabel(reason)
    },
    compactReasons(reasons) {
      if (!Array.isArray(reasons)) return ''
      return reasons.slice(0, 3).map(this.reasonLabel).join(' · ')
    },
    strategyAccountingValueClass(item) {
      const map = {
        success: 'text-success font-weight-bold',
        danger: 'text-danger font-weight-bold',
        warning: 'text-warning font-weight-bold',
      }
      return map[item && item.variant] || 'font-weight-bold'
    },
    strategyAccountingBadgeVariant(item) {
      const map = {
        success: 'light-success',
        danger: 'light-danger',
        warning: 'light-warning',
      }
      return map[item && item.variant] || 'light-secondary'
    },
    formatDate(value) {
      if (!value) return '—'
      return new Date(value).toLocaleString('tr-TR')
    },
  },
}
</script>

<style scoped>
.strategy-reading-line {
  border-bottom: 1px solid rgba(186, 191, 199, 0.35);
  padding: 0.45rem 0;
}

.strategy-reading-line:last-child {
  border-bottom: 0;
}

.strategy-reading-stats {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.strategy-reading-stat {
  border: 1px solid rgba(186, 191, 199, 0.45);
  border-radius: 6px;
  padding: 0.75rem;
}

.market-direction-panel {
  border: 1px solid rgba(186, 191, 199, 0.45);
  border-radius: 6px;
  padding: 0.85rem;
}

.market-direction-gauge,
.market-direction-mini {
  background: rgba(186, 191, 199, 0.28);
  border-radius: 999px;
  height: 0.55rem;
  overflow: hidden;
}

.market-direction-gauge {
  height: 0.7rem;
}

.market-direction-mini {
  min-width: 92px;
}

.market-direction-mini.wide {
  min-width: 100%;
}

.market-direction-gauge-fill,
.market-direction-mini-fill {
  height: 100%;
  min-width: 2%;
}

.market-direction-gauge-fill.is-long,
.market-direction-mini-fill.is-long {
  background: #28c76f;
}

.market-direction-gauge-fill.is-short,
.market-direction-mini-fill.is-short {
  background: #ea5455;
}

.market-direction-gauge-fill.is-range,
.market-direction-mini-fill.is-range {
  background: #00cfe8;
}

.market-direction-gauge-fill.is-mixed,
.market-direction-mini-fill.is-mixed {
  background: #ff9f43;
}

.market-direction-gauge-fill.is-empty,
.market-direction-mini-fill.is-empty {
  background: #b9b9c3;
}

.market-direction-coin {
  border-top: 1px solid rgba(186, 191, 199, 0.35);
  padding: 0.7rem 0;
}

.market-direction-coin:last-child {
  padding-bottom: 0;
}

.market-direction-timeframes {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.market-direction-timeframe {
  border: 1px solid rgba(186, 191, 199, 0.35);
  border-radius: 6px;
  padding: 0.65rem;
}

@media (max-width: 767.98px) {
  .strategy-reading-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .market-direction-timeframes {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
